type RawPoint = {
  latitude: number;
  longitude: number;
  index: number;
  // остальные поля могут быть любыми
  [k: string]: any;
};

type PointsDict = Record<string, RawPoint>;

/**
 * -> [[lat, lon], [lat, lon], ...] по возрастанию index
 */
export function toYandexPolylinePoints(obj: PointsDict): Array<[number, number]> {
  return Object.values(obj)
    .filter((p) => Number.isFinite(p.latitude) && Number.isFinite(p.longitude))
    .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
    .map((p) => [p.latitude, p.longitude]);
}

export const resData = {
    "code": "ok",
    "points": {
        "point_-136364456": {
            "id": -136364456,
            "latitude": 57.622631,
            "longitude": 64.384954,
            "index": 1,
            "is_stop": 1,
            "segment_id": -136452749,
            "segment_index": 1,
            "stop_id": "-136364456__nis",
            "stop_name": "с. Туринская Слобода АС",
            "transport_type": "АВТОБУС"
        },
        "point_-137899057": {
            "id": -137899057,
            "latitude": 57.622526,
            "longitude": 64.384723,
            "index": 2,
            "is_stop": 0,
            "segment_id": -136452749,
            "segment_index": 1
        },
        "point_-137899127": {
            "id": -137899127,
            "latitude": 57.622403,
            "longitude": 64.38484,
            "index": 3,
            "is_stop": 0,
            "segment_id": -136452749,
            "segment_index": 1
        },
        "point_-136452748": {
            "id": -136452748,
            "latitude": 57.622146,
            "longitude": 64.385358,
            "index": 4,
            "is_stop": 0,
            "segment_id": -136452749,
            "segment_index": 1
        },
        "point_-137915563": {
            "id": -137915563,
            "latitude": 57.621496,
            "longitude": 64.384865,
            "index": 6,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_1128675263": {
            "id": 1128675263,
            "latitude": 57.621333,
            "longitude": 64.384805,
            "index": 7,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137915745": {
            "id": -137915745,
            "latitude": 57.621195,
            "longitude": 64.384799,
            "index": 8,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137915939": {
            "id": -137915939,
            "latitude": 57.621109,
            "longitude": 64.384829,
            "index": 9,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-138259086": {
            "id": -138259086,
            "latitude": 57.620946,
            "longitude": 64.384977,
            "index": 10,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-138258538": {
            "id": -138258538,
            "latitude": 57.620706,
            "longitude": 64.3853,
            "index": 11,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137916142": {
            "id": -137916142,
            "latitude": 57.620036,
            "longitude": 64.386262,
            "index": 12,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137916372": {
            "id": -137916372,
            "latitude": 57.618688,
            "longitude": 64.38817,
            "index": 13,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137916644": {
            "id": -137916644,
            "latitude": 57.617754,
            "longitude": 64.389511,
            "index": 14,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-138259999": {
            "id": -138259999,
            "latitude": 57.617237,
            "longitude": 64.390277,
            "index": 15,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137916954": {
            "id": -137916954,
            "latitude": 57.616772,
            "longitude": 64.391044,
            "index": 16,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137917315": {
            "id": -137917315,
            "latitude": 57.616497,
            "longitude": 64.391801,
            "index": 17,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137917718": {
            "id": -137917718,
            "latitude": 57.615581,
            "longitude": 64.394718,
            "index": 18,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137915322": {
            "id": -137915322,
            "latitude": 57.615106,
            "longitude": 64.396167,
            "index": 19,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137915420": {
            "id": -137915420,
            "latitude": 57.614835,
            "longitude": 64.396727,
            "index": 20,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_1128677645": {
            "id": 1128677645,
            "latitude": 57.61451,
            "longitude": 64.397233,
            "index": 21,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-138263573": {
            "id": -138263573,
            "latitude": 57.614363,
            "longitude": 64.397457,
            "index": 22,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137915265": {
            "id": -137915265,
            "latitude": 57.614281,
            "longitude": 64.397541,
            "index": 23,
            "is_stop": 0,
            "segment_id": -137915266,
            "segment_index": 2
        },
        "point_-137922805": {
            "id": -137922805,
            "latitude": 57.614104,
            "longitude": 64.397527,
            "index": 25,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137923436": {
            "id": -137923436,
            "latitude": 57.613911,
            "longitude": 64.397367,
            "index": 26,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137924089": {
            "id": -137924089,
            "latitude": 57.613601,
            "longitude": 64.396958,
            "index": 27,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128680072": {
            "id": 1128680072,
            "latitude": 57.613408,
            "longitude": 64.396641,
            "index": 28,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137924767": {
            "id": -137924767,
            "latitude": 57.612936,
            "longitude": 64.395739,
            "index": 29,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137925500": {
            "id": -137925500,
            "latitude": 57.61248,
            "longitude": 64.394886,
            "index": 30,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128681115": {
            "id": 1128681115,
            "latitude": 57.61148,
            "longitude": 64.393406,
            "index": 31,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137922148": {
            "id": -137922148,
            "latitude": 57.610736,
            "longitude": 64.392233,
            "index": 32,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128682882": {
            "id": 1128682882,
            "latitude": 57.610192,
            "longitude": 64.391386,
            "index": 33,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137921531": {
            "id": -137921531,
            "latitude": 57.609603,
            "longitude": 64.390529,
            "index": 34,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137920959": {
            "id": -137920959,
            "latitude": 57.60823,
            "longitude": 64.38875,
            "index": 35,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128685074": {
            "id": 1128685074,
            "latitude": 57.607756,
            "longitude": 64.388245,
            "index": 36,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137920446": {
            "id": -137920446,
            "latitude": 57.607188,
            "longitude": 64.38765,
            "index": 37,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128686192": {
            "id": 1128686192,
            "latitude": 57.606907,
            "longitude": 64.387394,
            "index": 38,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137919993": {
            "id": -137919993,
            "latitude": 57.606607,
            "longitude": 64.38717,
            "index": 39,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137919585": {
            "id": -137919585,
            "latitude": 57.60635,
            "longitude": 64.387028,
            "index": 40,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128689187": {
            "id": 1128689187,
            "latitude": 57.606008,
            "longitude": 64.38693,
            "index": 41,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137918844": {
            "id": -137918844,
            "latitude": 57.605782,
            "longitude": 64.386892,
            "index": 42,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128691361": {
            "id": 1128691361,
            "latitude": 57.605114,
            "longitude": 64.386834,
            "index": 43,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137919153": {
            "id": -137919153,
            "latitude": 57.604988,
            "longitude": 64.386792,
            "index": 44,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137918595": {
            "id": -137918595,
            "latitude": 57.604894,
            "longitude": 64.386724,
            "index": 45,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128694492": {
            "id": 1128694492,
            "latitude": 57.604791,
            "longitude": 64.386566,
            "index": 46,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137918397": {
            "id": -137918397,
            "latitude": 57.603865,
            "longitude": 64.384401,
            "index": 47,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137918255": {
            "id": -137918255,
            "latitude": 57.602855,
            "longitude": 64.382091,
            "index": 48,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_-137918175": {
            "id": -137918175,
            "latitude": 57.602143,
            "longitude": 64.380425,
            "index": 49,
            "is_stop": 0,
            "segment_id": -137918176,
            "segment_index": 3
        },
        "point_1128698497": {
            "id": 1128698497,
            "latitude": 57.599587,
            "longitude": 64.37459,
            "index": 51,
            "is_stop": 0,
            "segment_id": -137926282,
            "segment_index": 4
        },
        "point_-137926327": {
            "id": -137926327,
            "latitude": 57.599077,
            "longitude": 64.373456,
            "index": 52,
            "is_stop": 0,
            "segment_id": -137926282,
            "segment_index": 4
        },
        "point_-137926281": {
            "id": -137926281,
            "latitude": 57.598454,
            "longitude": 64.372193,
            "index": 53,
            "is_stop": 0,
            "segment_id": -137926282,
            "segment_index": 4
        },
        "point_1128699219": {
            "id": 1128699219,
            "latitude": 57.597875,
            "longitude": 64.371087,
            "index": 55,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137928336": {
            "id": -137928336,
            "latitude": 57.597593,
            "longitude": 64.370587,
            "index": 56,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137927982": {
            "id": -137927982,
            "latitude": 57.597054,
            "longitude": 64.369716,
            "index": 57,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137927654": {
            "id": -137927654,
            "latitude": 57.595922,
            "longitude": 64.368118,
            "index": 58,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137927357": {
            "id": -137927357,
            "latitude": 57.594817,
            "longitude": 64.36659,
            "index": 59,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137927106": {
            "id": -137927106,
            "latitude": 57.593742,
            "longitude": 64.365107,
            "index": 60,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137926892": {
            "id": -137926892,
            "latitude": 57.592633,
            "longitude": 64.363568,
            "index": 61,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_1128701567": {
            "id": 1128701567,
            "latitude": 57.591719,
            "longitude": 64.362297,
            "index": 62,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137926723": {
            "id": -137926723,
            "latitude": 57.590934,
            "longitude": 64.361198,
            "index": 63,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137926598": {
            "id": -137926598,
            "latitude": 57.58951,
            "longitude": 64.359217,
            "index": 64,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_1128703422": {
            "id": 1128703422,
            "latitude": 57.588715,
            "longitude": 64.358119,
            "index": 65,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_1128704534": {
            "id": 1128704534,
            "latitude": 57.587967,
            "longitude": 64.357083,
            "index": 66,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_-137926403": {
            "id": -137926403,
            "latitude": 57.58775,
            "longitude": 64.3568,
            "index": 67,
            "is_stop": 0,
            "segment_id": -137926404,
            "segment_index": 5
        },
        "point_1128706606": {
            "id": 1128706606,
            "latitude": 57.587211,
            "longitude": 64.356059,
            "index": 69,
            "is_stop": 0,
            "segment_id": -137928716,
            "segment_index": 6
        },
        "point_1128709448": {
            "id": 1128709448,
            "latitude": 57.579974,
            "longitude": 64.3461,
            "index": 70,
            "is_stop": 0,
            "segment_id": -137928716,
            "segment_index": 6
        },
        "point_1128709588": {
            "id": 1128709588,
            "latitude": 57.578184,
            "longitude": 64.34367,
            "index": 71,
            "is_stop": 0,
            "segment_id": -137928716,
            "segment_index": 6
        },
        "point_1128709781": {
            "id": 1128709781,
            "latitude": 57.575894,
            "longitude": 64.340518,
            "index": 72,
            "is_stop": 0,
            "segment_id": -137928716,
            "segment_index": 6
        },
        "point_1128712051": {
            "id": 1128712051,
            "latitude": 57.57431,
            "longitude": 64.338337,
            "index": 73,
            "is_stop": 0,
            "segment_id": -137928716,
            "segment_index": 6
        },
        "point_1128712655": {
            "id": 1128712655,
            "latitude": 57.573508,
            "longitude": 64.337251,
            "index": 74,
            "is_stop": 0,
            "segment_id": -137928716,
            "segment_index": 6
        },
        "point_1128713258": {
            "id": 1128713258,
            "latitude": 57.572729,
            "longitude": 64.336189,
            "index": 75,
            "is_stop": 0,
            "segment_id": -137928716,
            "segment_index": 6
        },
        "point_-137928715": {
            "id": -137928715,
            "latitude": 57.571412,
            "longitude": 64.334394,
            "index": 76,
            "is_stop": 0,
            "segment_id": -137928716,
            "segment_index": 6
        },
        "point_1128715975": {
            "id": 1128715975,
            "latitude": 57.570009,
            "longitude": 64.332476,
            "index": 78,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128717470": {
            "id": 1128717470,
            "latitude": 57.56883,
            "longitude": 64.330875,
            "index": 79,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128721015": {
            "id": 1128721015,
            "latitude": 57.567961,
            "longitude": 64.329685,
            "index": 80,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128724901": {
            "id": 1128724901,
            "latitude": 57.567268,
            "longitude": 64.328717,
            "index": 81,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137942613": {
            "id": -137942613,
            "latitude": 57.566598,
            "longitude": 64.327745,
            "index": 82,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128726726": {
            "id": 1128726726,
            "latitude": 57.566109,
            "longitude": 64.327022,
            "index": 83,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137941185": {
            "id": -137941185,
            "latitude": 57.565739,
            "longitude": 64.326447,
            "index": 84,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128730978": {
            "id": 1128730978,
            "latitude": 57.565273,
            "longitude": 64.325705,
            "index": 85,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137939810": {
            "id": -137939810,
            "latitude": 57.564869,
            "longitude": 64.325019,
            "index": 86,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128735294": {
            "id": 1128735294,
            "latitude": 57.56422,
            "longitude": 64.323816,
            "index": 87,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137938493": {
            "id": -137938493,
            "latitude": 57.563499,
            "longitude": 64.322492,
            "index": 88,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128742708": {
            "id": 1128742708,
            "latitude": 57.562643,
            "longitude": 64.320899,
            "index": 89,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137937226": {
            "id": -137937226,
            "latitude": 57.562136,
            "longitude": 64.319995,
            "index": 90,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128745108": {
            "id": 1128745108,
            "latitude": 57.561477,
            "longitude": 64.318937,
            "index": 91,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137936031": {
            "id": -137936031,
            "latitude": 57.560884,
            "longitude": 64.318043,
            "index": 92,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128750345": {
            "id": 1128750345,
            "latitude": 57.560067,
            "longitude": 64.316892,
            "index": 93,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137934902": {
            "id": -137934902,
            "latitude": 57.559486,
            "longitude": 64.316153,
            "index": 94,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128755584": {
            "id": 1128755584,
            "latitude": 57.559058,
            "longitude": 64.31566,
            "index": 95,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137933904": {
            "id": -137933904,
            "latitude": 57.558536,
            "longitude": 64.315119,
            "index": 96,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128758128": {
            "id": 1128758128,
            "latitude": 57.558308,
            "longitude": 64.314912,
            "index": 97,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137932834": {
            "id": -137932834,
            "latitude": 57.556914,
            "longitude": 64.313856,
            "index": 98,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137931979": {
            "id": -137931979,
            "latitude": 57.555479,
            "longitude": 64.312822,
            "index": 99,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137931223": {
            "id": -137931223,
            "latitude": 57.554244,
            "longitude": 64.311924,
            "index": 100,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128770070": {
            "id": 1128770070,
            "latitude": 57.553407,
            "longitude": 64.311316,
            "index": 101,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137930555": {
            "id": -137930555,
            "latitude": 57.552621,
            "longitude": 64.310764,
            "index": 102,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137929997": {
            "id": -137929997,
            "latitude": 57.551283,
            "longitude": 64.309815,
            "index": 103,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137929536": {
            "id": -137929536,
            "latitude": 57.550007,
            "longitude": 64.308916,
            "index": 104,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128779751": {
            "id": 1128779751,
            "latitude": 57.548826,
            "longitude": 64.308148,
            "index": 105,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137929183": {
            "id": -137929183,
            "latitude": 57.547357,
            "longitude": 64.307202,
            "index": 106,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137928939": {
            "id": -137928939,
            "latitude": 57.546021,
            "longitude": 64.306316,
            "index": 107,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_-137928808": {
            "id": -137928808,
            "latitude": 57.545548,
            "longitude": 64.305982,
            "index": 108,
            "is_stop": 0,
            "segment_id": -137928809,
            "segment_index": 7
        },
        "point_1128786578": {
            "id": 1128786578,
            "latitude": 57.54498,
            "longitude": 64.305487,
            "index": 110,
            "is_stop": 0,
            "segment_id": -137944109,
            "segment_index": 8
        },
        "point_1128786634": {
            "id": 1128786634,
            "latitude": 57.544168,
            "longitude": 64.304727,
            "index": 111,
            "is_stop": 0,
            "segment_id": -137944109,
            "segment_index": 8
        },
        "point_1128790282": {
            "id": 1128790282,
            "latitude": 57.543379,
            "longitude": 64.303972,
            "index": 112,
            "is_stop": 0,
            "segment_id": -137944109,
            "segment_index": 8
        },
        "point_1128790376": {
            "id": 1128790376,
            "latitude": 57.54137,
            "longitude": 64.302007,
            "index": 113,
            "is_stop": 0,
            "segment_id": -137944109,
            "segment_index": 8
        },
        "point_-137944108": {
            "id": -137944108,
            "latitude": 57.540114,
            "longitude": 64.300762,
            "index": 114,
            "is_stop": 0,
            "segment_id": -137944109,
            "segment_index": 8
        },
        "point_-137944151": {
            "id": -137944151,
            "latitude": 57.540052,
            "longitude": 64.30059,
            "index": 116,
            "is_stop": 1,
            "segment_id": -137944152,
            "segment_index": 9,
            "stop_id": "-137944151__nis",
            "stop_name": "д. Ивановка (Слободо-Туринский р-н)",
            "transport_type": "АВТОБУС"
        },
        "point_-137944229": {
            "id": -137944229,
            "latitude": 57.539908,
            "longitude": 64.300569,
            "index": 118,
            "is_stop": 0,
            "segment_id": -137944230,
            "segment_index": 10
        },
        "point_1128795385": {
            "id": 1128795385,
            "latitude": 57.539316,
            "longitude": 64.300014,
            "index": 120,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128796311": {
            "id": 1128796311,
            "latitude": 57.53853,
            "longitude": 64.299335,
            "index": 121,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128797354": {
            "id": 1128797354,
            "latitude": 57.537497,
            "longitude": 64.298449,
            "index": 122,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_-137944905": {
            "id": -137944905,
            "latitude": 57.536631,
            "longitude": 64.297716,
            "index": 123,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128797943": {
            "id": 1128797943,
            "latitude": 57.534601,
            "longitude": 64.295972,
            "index": 124,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_-137945151": {
            "id": -137945151,
            "latitude": 57.534321,
            "longitude": 64.295739,
            "index": 125,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128799121": {
            "id": 1128799121,
            "latitude": 57.533541,
            "longitude": 64.295091,
            "index": 126,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128799645": {
            "id": 1128799645,
            "latitude": 57.532242,
            "longitude": 64.293967,
            "index": 127,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128800991": {
            "id": 1128800991,
            "latitude": 57.531228,
            "longitude": 64.293094,
            "index": 128,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128801612": {
            "id": 1128801612,
            "latitude": 57.529713,
            "longitude": 64.29173,
            "index": 129,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_-137944692": {
            "id": -137944692,
            "latitude": 57.529249,
            "longitude": 64.291295,
            "index": 130,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_-137944525": {
            "id": -137944525,
            "latitude": 57.529063,
            "longitude": 64.291122,
            "index": 131,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128802426": {
            "id": 1128802426,
            "latitude": 57.528222,
            "longitude": 64.290321,
            "index": 132,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128804051": {
            "id": 1128804051,
            "latitude": 57.527563,
            "longitude": 64.28963,
            "index": 133,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_-137944409": {
            "id": -137944409,
            "latitude": 57.527212,
            "longitude": 64.28922,
            "index": 134,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_-137944342": {
            "id": -137944342,
            "latitude": 57.526721,
            "longitude": 64.288681,
            "index": 135,
            "is_stop": 0,
            "segment_id": -137944343,
            "segment_index": 11
        },
        "point_1128805806": {
            "id": 1128805806,
            "latitude": 57.526179,
            "longitude": 64.288079,
            "index": 137,
            "is_stop": 0,
            "segment_id": -137945482,
            "segment_index": 12
        },
        "point_1128806936": {
            "id": 1128806936,
            "latitude": 57.52477,
            "longitude": 64.28645,
            "index": 138,
            "is_stop": 0,
            "segment_id": -137945482,
            "segment_index": 12
        },
        "point_1128807101": {
            "id": 1128807101,
            "latitude": 57.523497,
            "longitude": 64.284862,
            "index": 139,
            "is_stop": 0,
            "segment_id": -137945482,
            "segment_index": 12
        },
        "point_-137945481": {
            "id": -137945481,
            "latitude": 57.521717,
            "longitude": 64.282673,
            "index": 140,
            "is_stop": 0,
            "segment_id": -137945482,
            "segment_index": 12
        },
        "point_-137945526": {
            "id": -137945526,
            "latitude": 57.521641,
            "longitude": 64.282578,
            "index": 142,
            "is_stop": 0,
            "segment_id": -137945527,
            "segment_index": 13
        },
        "point_1128809320": {
            "id": 1128809320,
            "latitude": 57.521483,
            "longitude": 64.282379,
            "index": 144,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143002972": {
            "id": -143002972,
            "latitude": 57.521081,
            "longitude": 64.281867,
            "index": 145,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143000684": {
            "id": -143000684,
            "latitude": 57.520447,
            "longitude": 64.281089,
            "index": 146,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143005205": {
            "id": -143005205,
            "latitude": 57.518826,
            "longitude": 64.279081,
            "index": 147,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128862330": {
            "id": 1128862330,
            "latitude": 57.517378,
            "longitude": 64.277293,
            "index": 148,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143157296": {
            "id": -143157296,
            "latitude": 57.515381,
            "longitude": 64.274843,
            "index": 149,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137972343": {
            "id": -137972343,
            "latitude": 57.513296,
            "longitude": 64.2723,
            "index": 150,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128868510": {
            "id": 1128868510,
            "latitude": 57.512676,
            "longitude": 64.271492,
            "index": 151,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137970433": {
            "id": -137970433,
            "latitude": 57.51195,
            "longitude": 64.27047,
            "index": 152,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143159952": {
            "id": -143159952,
            "latitude": 57.510591,
            "longitude": 64.268364,
            "index": 153,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143162737": {
            "id": -143162737,
            "latitude": 57.509737,
            "longitude": 64.266937,
            "index": 154,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128877665": {
            "id": 1128877665,
            "latitude": 57.508854,
            "longitude": 64.265375,
            "index": 155,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143165537": {
            "id": -143165537,
            "latitude": 57.508084,
            "longitude": 64.263893,
            "index": 156,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137963444": {
            "id": -137963444,
            "latitude": 57.506315,
            "longitude": 64.260197,
            "index": 157,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128885052": {
            "id": 1128885052,
            "latitude": 57.505488,
            "longitude": 64.258279,
            "index": 158,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137965006": {
            "id": -137965006,
            "latitude": 57.504743,
            "longitude": 64.256423,
            "index": 159,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128892344": {
            "id": 1128892344,
            "latitude": 57.503706,
            "longitude": 64.253649,
            "index": 160,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137960597": {
            "id": -137960597,
            "latitude": 57.502804,
            "longitude": 64.250995,
            "index": 161,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128899579": {
            "id": 1128899579,
            "latitude": 57.501648,
            "longitude": 64.247181,
            "index": 162,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143171526": {
            "id": -143171526,
            "latitude": 57.500548,
            "longitude": 64.243313,
            "index": 163,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143169885": {
            "id": -143169885,
            "latitude": 57.499214,
            "longitude": 64.238321,
            "index": 164,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143173510": {
            "id": -143173510,
            "latitude": 57.497445,
            "longitude": 64.231648,
            "index": 165,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128916814": {
            "id": 1128916814,
            "latitude": 57.497037,
            "longitude": 64.229935,
            "index": 166,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128909029": {
            "id": 1128909029,
            "latitude": 57.496465,
            "longitude": 64.227339,
            "index": 167,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128926333": {
            "id": 1128926333,
            "latitude": 57.49611,
            "longitude": 64.225587,
            "index": 168,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-143179960": {
            "id": -143179960,
            "latitude": 57.495752,
            "longitude": 64.223757,
            "index": 169,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128933310": {
            "id": 1128933310,
            "latitude": 57.495509,
            "longitude": 64.222402,
            "index": 170,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128940581": {
            "id": 1128940581,
            "latitude": 57.495015,
            "longitude": 64.219469,
            "index": 171,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128951266": {
            "id": 1128951266,
            "latitude": 57.494464,
            "longitude": 64.216137,
            "index": 172,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1128961333": {
            "id": 1128961333,
            "latitude": 57.494231,
            "longitude": 64.214633,
            "index": 173,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137977558": {
            "id": -137977558,
            "latitude": 57.494005,
            "longitude": 64.212968,
            "index": 174,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137976924": {
            "id": -137976924,
            "latitude": 57.493704,
            "longitude": 64.210535,
            "index": 175,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_1129014862": {
            "id": 1129014862,
            "latitude": 57.493577,
            "longitude": 64.209105,
            "index": 176,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137975830": {
            "id": -137975830,
            "latitude": 57.493484,
            "longitude": 64.207509,
            "index": 177,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137976352": {
            "id": -137976352,
            "latitude": 57.493432,
            "longitude": 64.205287,
            "index": 178,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137975370": {
            "id": -137975370,
            "latitude": 57.493422,
            "longitude": 64.204127,
            "index": 179,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137974979": {
            "id": -137974979,
            "latitude": 57.493369,
            "longitude": 64.195642,
            "index": 180,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137974665": {
            "id": -137974665,
            "latitude": 57.493308,
            "longitude": 64.18781,
            "index": 181,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137974443": {
            "id": -137974443,
            "latitude": 57.493258,
            "longitude": 64.181493,
            "index": 182,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137974322": {
            "id": -137974322,
            "latitude": 57.493193,
            "longitude": 64.174654,
            "index": 183,
            "is_stop": 0,
            "segment_id": -137974323,
            "segment_index": 14
        },
        "point_-137978857": {
            "id": -137978857,
            "latitude": 57.493141,
            "longitude": 64.166938,
            "index": 185,
            "is_stop": 0,
            "segment_id": -137978232,
            "segment_index": 15
        },
        "point_-137978450": {
            "id": -137978450,
            "latitude": 57.493234,
            "longitude": 64.163115,
            "index": 186,
            "is_stop": 0,
            "segment_id": -137978232,
            "segment_index": 15
        },
        "point_-137978231": {
            "id": -137978231,
            "latitude": 57.49316,
            "longitude": 64.162686,
            "index": 187,
            "is_stop": 0,
            "segment_id": -137978232,
            "segment_index": 15
        },
        "point_-137978301": {
            "id": -137978301,
            "latitude": 57.493207,
            "longitude": 64.162508,
            "index": 189,
            "is_stop": 1,
            "segment_id": -137978302,
            "segment_index": 16,
            "stop_id": "-137978301__nis",
            "stop_name": "пов. с. Бобровское (Слободо-Туринский р-н)",
            "transport_type": "АВТОБУС"
        },
        "point_-224487030": {
            "id": -224487030,
            "latitude": 57.493157,
            "longitude": 64.162281,
            "index": 191,
            "is_stop": 0,
            "segment_id": -137979389,
            "segment_index": 17
        },
        "point_-224486945": {
            "id": -224486945,
            "latitude": 57.493138,
            "longitude": 64.161337,
            "index": 193,
            "is_stop": 0,
            "segment_id": -224487150,
            "segment_index": 18
        },
        "point_1129028051": {
            "id": 1129028051,
            "latitude": 57.493085,
            "longitude": 64.160239,
            "index": 194,
            "is_stop": 0,
            "segment_id": -224487150,
            "segment_index": 18
        },
        "point_-224486883": {
            "id": -224486883,
            "latitude": 57.492989,
            "longitude": 64.158889,
            "index": 195,
            "is_stop": 0,
            "segment_id": -224487150,
            "segment_index": 18
        },
        "point_-137979388": {
            "id": -137979388,
            "latitude": 57.492551,
            "longitude": 64.155072,
            "index": 196,
            "is_stop": 0,
            "segment_id": -224487150,
            "segment_index": 18
        },
        "point_-137979411": {
            "id": -137979411,
            "latitude": 57.492466,
            "longitude": 64.154205,
            "index": 198,
            "is_stop": 0,
            "segment_id": -137979412,
            "segment_index": 19
        },
        "point_-138194584": {
            "id": -138194584,
            "latitude": 57.492446,
            "longitude": 64.154028,
            "index": 200,
            "is_stop": 0,
            "segment_id": -143021698,
            "segment_index": 20
        },
        "point_-143087872": {
            "id": -143087872,
            "latitude": 57.491723,
            "longitude": 64.148833,
            "index": 202,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143092229": {
            "id": -143092229,
            "latitude": 57.491462,
            "longitude": 64.14722,
            "index": 203,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143083586": {
            "id": -143083586,
            "latitude": 57.491015,
            "longitude": 64.144898,
            "index": 204,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143079378": {
            "id": -143079378,
            "latitude": 57.490063,
            "longitude": 64.141014,
            "index": 205,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143075231": {
            "id": -143075231,
            "latitude": 57.489312,
            "longitude": 64.138395,
            "index": 206,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143071236": {
            "id": -143071236,
            "latitude": 57.487612,
            "longitude": 64.134111,
            "index": 207,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143067276": {
            "id": -143067276,
            "latitude": 57.485081,
            "longitude": 64.128238,
            "index": 208,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143063407": {
            "id": -143063407,
            "latitude": 57.482801,
            "longitude": 64.123066,
            "index": 209,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143059642": {
            "id": -143059642,
            "latitude": 57.480277,
            "longitude": 64.117302,
            "index": 210,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143055961": {
            "id": -143055961,
            "latitude": 57.478115,
            "longitude": 64.112615,
            "index": 211,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143052428": {
            "id": -143052428,
            "latitude": 57.476154,
            "longitude": 64.109145,
            "index": 212,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143049004": {
            "id": -143049004,
            "latitude": 57.473731,
            "longitude": 64.105008,
            "index": 213,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143045760": {
            "id": -143045760,
            "latitude": 57.47161,
            "longitude": 64.101233,
            "index": 214,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143042650": {
            "id": -143042650,
            "latitude": 57.467772,
            "longitude": 64.094605,
            "index": 215,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143036994": {
            "id": -143036994,
            "latitude": 57.465654,
            "longitude": 64.09085,
            "index": 216,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143039720": {
            "id": -143039720,
            "latitude": 57.464681,
            "longitude": 64.089044,
            "index": 217,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143034467": {
            "id": -143034467,
            "latitude": 57.463697,
            "longitude": 64.087002,
            "index": 218,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143032136": {
            "id": -143032136,
            "latitude": 57.46139,
            "longitude": 64.081993,
            "index": 219,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143029999": {
            "id": -143029999,
            "latitude": 57.459496,
            "longitude": 64.0778,
            "index": 220,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143028091": {
            "id": -143028091,
            "latitude": 57.457557,
            "longitude": 64.073588,
            "index": 221,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143026421": {
            "id": -143026421,
            "latitude": 57.455399,
            "longitude": 64.068814,
            "index": 222,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143025000": {
            "id": -143025000,
            "latitude": 57.452402,
            "longitude": 64.062247,
            "index": 223,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143023534": {
            "id": -143023534,
            "latitude": 57.45009,
            "longitude": 64.057119,
            "index": 224,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143022642": {
            "id": -143022642,
            "latitude": 57.447513,
            "longitude": 64.051365,
            "index": 225,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143022036": {
            "id": -143022036,
            "latitude": 57.446218,
            "longitude": 64.047904,
            "index": 226,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143021723": {
            "id": -143021723,
            "latitude": 57.444101,
            "longitude": 64.04181,
            "index": 227,
            "is_stop": 0,
            "segment_id": -143021724,
            "segment_index": 21
        },
        "point_-143096967": {
            "id": -143096967,
            "latitude": 57.444124,
            "longitude": 64.041568,
            "index": 229,
            "is_stop": 1,
            "segment_id": -143096968,
            "segment_index": 22,
            "stop_id": "-143096967__nis",
            "stop_name": "пов. д. Ключевая (Байкаловский р-н)",
            "transport_type": "АВТОБУС"
        },
        "point_-143097011": {
            "id": -143097011,
            "latitude": 57.443962,
            "longitude": 64.041492,
            "index": 231,
            "is_stop": 0,
            "segment_id": -143097012,
            "segment_index": 23
        },
        "point_-143097049": {
            "id": -143097049,
            "latitude": 57.438093,
            "longitude": 64.024803,
            "index": 233,
            "is_stop": 0,
            "segment_id": -143097050,
            "segment_index": 24
        },
        "point_-224489190": {
            "id": -224489190,
            "latitude": 57.436691,
            "longitude": 64.020168,
            "index": 235,
            "is_stop": 0,
            "segment_id": -143097120,
            "segment_index": 25
        },
        "point_-143097464": {
            "id": -143097464,
            "latitude": 57.430776,
            "longitude": 63.997724,
            "index": 236,
            "is_stop": 0,
            "segment_id": -143097120,
            "segment_index": 25
        },
        "point_-143098406": {
            "id": -143098406,
            "latitude": 57.427793,
            "longitude": 63.986607,
            "index": 237,
            "is_stop": 0,
            "segment_id": -143097120,
            "segment_index": 25
        },
        "point_-143097240": {
            "id": -143097240,
            "latitude": 57.427254,
            "longitude": 63.984434,
            "index": 238,
            "is_stop": 0,
            "segment_id": -143097120,
            "segment_index": 25
        },
        "point_-143097879": {
            "id": -143097879,
            "latitude": 57.427039,
            "longitude": 63.983227,
            "index": 239,
            "is_stop": 0,
            "segment_id": -143097120,
            "segment_index": 25
        },
        "point_-224494485": {
            "id": -224494485,
            "latitude": 57.426731,
            "longitude": 63.981347,
            "index": 240,
            "is_stop": 0,
            "segment_id": -143097120,
            "segment_index": 25
        },
        "point_-224493794": {
            "id": -224493794,
            "latitude": 57.426505,
            "longitude": 63.979402,
            "index": 241,
            "is_stop": 0,
            "segment_id": -143097120,
            "segment_index": 25
        },
        "point_-143097119": {
            "id": -143097119,
            "latitude": 57.426492,
            "longitude": 63.975813,
            "index": 242,
            "is_stop": 0,
            "segment_id": -143097120,
            "segment_index": 25
        },
        "point_-143099042": {
            "id": -143099042,
            "latitude": 57.426578,
            "longitude": 63.975584,
            "index": 244,
            "is_stop": 1,
            "segment_id": -143099043,
            "segment_index": 26,
            "stop_id": "-143099042__nis",
            "stop_name": "пов. д. Пелевина (Байкаловский р-н)",
            "transport_type": "АВТОБУС"
        },
        "point_-143099065": {
            "id": -143099065,
            "latitude": 57.426475,
            "longitude": 63.975349,
            "index": 246,
            "is_stop": 0,
            "segment_id": -143099066,
            "segment_index": 27
        },
        "point_-143108373": {
            "id": -143108373,
            "latitude": 57.426488,
            "longitude": 63.972707,
            "index": 248,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143107074": {
            "id": -143107074,
            "latitude": 57.426527,
            "longitude": 63.966934,
            "index": 249,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143105851": {
            "id": -143105851,
            "latitude": 57.426549,
            "longitude": 63.960915,
            "index": 250,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143104703": {
            "id": -143104703,
            "latitude": 57.426476,
            "longitude": 63.957715,
            "index": 251,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143103644": {
            "id": -143103644,
            "latitude": 57.426355,
            "longitude": 63.95276,
            "index": 252,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143102681": {
            "id": -143102681,
            "latitude": 57.42623,
            "longitude": 63.947519,
            "index": 253,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143101821": {
            "id": -143101821,
            "latitude": 57.426039,
            "longitude": 63.940565,
            "index": 254,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143101075": {
            "id": -143101075,
            "latitude": 57.425969,
            "longitude": 63.937519,
            "index": 255,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143100441": {
            "id": -143100441,
            "latitude": 57.425915,
            "longitude": 63.935509,
            "index": 256,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143099925": {
            "id": -143099925,
            "latitude": 57.425779,
            "longitude": 63.932117,
            "index": 257,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143099530": {
            "id": -143099530,
            "latitude": 57.425562,
            "longitude": 63.927815,
            "index": 258,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143099259": {
            "id": -143099259,
            "latitude": 57.425425,
            "longitude": 63.925203,
            "index": 259,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-224497462": {
            "id": -224497462,
            "latitude": 57.425243,
            "longitude": 63.922911,
            "index": 260,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143099115": {
            "id": -143099115,
            "latitude": 57.42498,
            "longitude": 63.920963,
            "index": 261,
            "is_stop": 0,
            "segment_id": -143099116,
            "segment_index": 28
        },
        "point_-143114090": {
            "id": -143114090,
            "latitude": 57.425038,
            "longitude": 63.920734,
            "index": 263,
            "is_stop": 1,
            "segment_id": -143114091,
            "segment_index": 29,
            "stop_id": "-143114090__nis",
            "stop_name": "пов. д. Сафонова (Байкаловский р-н)",
            "transport_type": "АВТОБУС"
        },
        "point_-143114287": {
            "id": -143114287,
            "latitude": 57.424917,
            "longitude": 63.920621,
            "index": 265,
            "is_stop": 0,
            "segment_id": -143114288,
            "segment_index": 30
        },
        "point_-143116055": {
            "id": -143116055,
            "latitude": 57.424846,
            "longitude": 63.92017,
            "index": 267,
            "is_stop": 0,
            "segment_id": -143114311,
            "segment_index": 31
        },
        "point_-143115620": {
            "id": -143115620,
            "latitude": 57.423966,
            "longitude": 63.914311,
            "index": 268,
            "is_stop": 0,
            "segment_id": -143114311,
            "segment_index": 31
        },
        "point_-143115232": {
            "id": -143115232,
            "latitude": 57.423293,
            "longitude": 63.909823,
            "index": 269,
            "is_stop": 0,
            "segment_id": -143114311,
            "segment_index": 31
        },
        "point_-143114894": {
            "id": -143114894,
            "latitude": 57.422688,
            "longitude": 63.905892,
            "index": 270,
            "is_stop": 0,
            "segment_id": -143114311,
            "segment_index": 31
        },
        "point_-143116527": {
            "id": -143116527,
            "latitude": 57.420947,
            "longitude": 63.894374,
            "index": 271,
            "is_stop": 0,
            "segment_id": -143114311,
            "segment_index": 31
        },
        "point_-143114613": {
            "id": -143114613,
            "latitude": 57.420333,
            "longitude": 63.890184,
            "index": 272,
            "is_stop": 0,
            "segment_id": -143114311,
            "segment_index": 31
        },
        "point_-143114417": {
            "id": -143114417,
            "latitude": 57.420052,
            "longitude": 63.888048,
            "index": 273,
            "is_stop": 0,
            "segment_id": -143114311,
            "segment_index": 31
        },
        "point_-143114310": {
            "id": -143114310,
            "latitude": 57.419645,
            "longitude": 63.885044,
            "index": 274,
            "is_stop": 0,
            "segment_id": -143114311,
            "segment_index": 31
        },
        "point_-143130370": {
            "id": -143130370,
            "latitude": 57.415096,
            "longitude": 63.84495,
            "index": 276,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143128326": {
            "id": -143128326,
            "latitude": 57.414216,
            "longitude": 63.838064,
            "index": 277,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143126425": {
            "id": -143126425,
            "latitude": 57.413333,
            "longitude": 63.831423,
            "index": 278,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143124669": {
            "id": -143124669,
            "latitude": 57.412519,
            "longitude": 63.825221,
            "index": 279,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143123069": {
            "id": -143123069,
            "latitude": 57.411443,
            "longitude": 63.816774,
            "index": 280,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143121642": {
            "id": -143121642,
            "latitude": 57.411028,
            "longitude": 63.81231,
            "index": 281,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143120401": {
            "id": -143120401,
            "latitude": 57.410483,
            "longitude": 63.806495,
            "index": 282,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143119350": {
            "id": -143119350,
            "latitude": 57.409699,
            "longitude": 63.798213,
            "index": 283,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143118504": {
            "id": -143118504,
            "latitude": 57.409547,
            "longitude": 63.796659,
            "index": 284,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143117862": {
            "id": -143117862,
            "latitude": 57.40913,
            "longitude": 63.794201,
            "index": 285,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143117428": {
            "id": -143117428,
            "latitude": 57.409005,
            "longitude": 63.793664,
            "index": 286,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-143117203": {
            "id": -143117203,
            "latitude": 57.408476,
            "longitude": 63.791291,
            "index": 287,
            "is_stop": 0,
            "segment_id": -143117204,
            "segment_index": 32
        },
        "point_-128612235": {
            "id": -128612235,
            "latitude": 57.408651,
            "longitude": 63.789588,
            "index": 289,
            "is_stop": 0,
            "segment_id": -143132782,
            "segment_index": 33
        },
        "point_-143132810": {
            "id": -143132810,
            "latitude": 57.408717,
            "longitude": 63.789196,
            "index": 291,
            "is_stop": 0,
            "segment_id": -143132811,
            "segment_index": 34
        },
        "point_-143144700": {
            "id": -143144700,
            "latitude": 57.407541,
            "longitude": 63.788453,
            "index": 293,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143143542": {
            "id": -143143542,
            "latitude": 57.40704,
            "longitude": 63.787887,
            "index": 294,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143142433": {
            "id": -143142433,
            "latitude": 57.405772,
            "longitude": 63.786143,
            "index": 295,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143141376": {
            "id": -143141376,
            "latitude": 57.40546,
            "longitude": 63.785537,
            "index": 296,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143139396": {
            "id": -143139396,
            "latitude": 57.405414,
            "longitude": 63.784123,
            "index": 297,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143140356": {
            "id": -143140356,
            "latitude": 57.404958,
            "longitude": 63.780265,
            "index": 298,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143138485": {
            "id": -143138485,
            "latitude": 57.40486,
            "longitude": 63.778317,
            "index": 299,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143137623": {
            "id": -143137623,
            "latitude": 57.404543,
            "longitude": 63.777112,
            "index": 300,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143136811": {
            "id": -143136811,
            "latitude": 57.404203,
            "longitude": 63.776591,
            "index": 301,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143136068": {
            "id": -143136068,
            "latitude": 57.40107,
            "longitude": 63.773462,
            "index": 302,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143135392": {
            "id": -143135392,
            "latitude": 57.399143,
            "longitude": 63.771418,
            "index": 303,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143134787": {
            "id": -143134787,
            "latitude": 57.397824,
            "longitude": 63.767977,
            "index": 304,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143134249": {
            "id": -143134249,
            "latitude": 57.397542,
            "longitude": 63.767373,
            "index": 305,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143133788": {
            "id": -143133788,
            "latitude": 57.395467,
            "longitude": 63.764181,
            "index": 306,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143133414": {
            "id": -143133414,
            "latitude": 57.393366,
            "longitude": 63.761108,
            "index": 307,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143132937": {
            "id": -143132937,
            "latitude": 57.392454,
            "longitude": 63.759734,
            "index": 308,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-143133129": {
            "id": -143133129,
            "latitude": 57.391628,
            "longitude": 63.758664,
            "index": 309,
            "is_stop": 0,
            "segment_id": -143132834,
            "segment_index": 35
        },
        "point_-128322865": {
            "id": -128322865,
            "latitude": 57.391103,
            "longitude": 63.758113,
            "index": 314,
            "is_stop": 0,
            "segment_id": -143146252,
            "segment_index": 37
        },
        "point_-128322946": {
            "id": -128322946,
            "latitude": 57.390912,
            "longitude": 63.758488,
            "index": 316,
            "is_stop": 1,
            "segment_id": -128322947,
            "segment_index": 38,
            "stop_id": "-128322946__nis",
            "stop_name": "с. Байкалово АС",
            "transport_type": "АВТОБУС"
        },
        "point_-128606666": {
            "id": -128606666,
            "latitude": 57.39101,
            "longitude": 63.758631,
            "index": 318,
            "is_stop": 0,
            "segment_id": -143146379,
            "segment_index": 39
        },
        "point_-128606716": {
            "id": -128606716,
            "latitude": 57.391201,
            "longitude": 63.758288,
            "index": 320,
            "is_stop": 0,
            "segment_id": -128606717,
            "segment_index": 40
        },
        "point_-143132833": {
            "id": -143132833,
            "latitude": 57.39131,
            "longitude": 63.758142,
            "index": 322,
            "is_stop": 0,
            "segment_id": -143146535,
            "segment_index": 41
        },
        "point_-143146557": {
            "id": -143146557,
            "latitude": 57.391306,
            "longitude": 63.757894,
            "index": 324,
            "is_stop": 0,
            "segment_id": -143146558,
            "segment_index": 42
        },
        "point_-136101735": {
            "id": -136101735,
            "latitude": 57.391185,
            "longitude": 63.757911,
            "index": 326,
            "is_stop": 0,
            "segment_id": -143146583,
            "segment_index": 43
        },
        "point_1140095956": {
            "id": 1140095956,
            "latitude": 57.389784,
            "longitude": 63.755623,
            "index": 328,
            "is_stop": 0,
            "segment_id": -136101765,
            "segment_index": 44
        },
        "point_1140095768": {
            "id": 1140095768,
            "latitude": 57.388969,
            "longitude": 63.754172,
            "index": 330,
            "is_stop": 0,
            "segment_id": 1148165422,
            "segment_index": 45
        },
        "point_1140095625": {
            "id": 1140095625,
            "latitude": 57.386975,
            "longitude": 63.751039,
            "index": 331,
            "is_stop": 0,
            "segment_id": 1148165422,
            "segment_index": 45
        },
        "point_-136101764": {
            "id": -136101764,
            "latitude": 57.386656,
            "longitude": 63.750457,
            "index": 332,
            "is_stop": 0,
            "segment_id": 1148165422,
            "segment_index": 45
        },
        "point_1140094744": {
            "id": 1140094744,
            "latitude": 57.386908,
            "longitude": 63.750412,
            "index": 334,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_1140095008": {
            "id": 1140095008,
            "latitude": 57.387639,
            "longitude": 63.750243,
            "index": 335,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149264758": {
            "id": -149264758,
            "latitude": 57.387785,
            "longitude": 63.750186,
            "index": 336,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149264786": {
            "id": -149264786,
            "latitude": 57.388068,
            "longitude": 63.750106,
            "index": 337,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149264819": {
            "id": -149264819,
            "latitude": 57.388355,
            "longitude": 63.74999,
            "index": 338,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_1140094292": {
            "id": 1140094292,
            "latitude": 57.388673,
            "longitude": 63.749845,
            "index": 339,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149264853": {
            "id": -149264853,
            "latitude": 57.388921,
            "longitude": 63.749685,
            "index": 340,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149264887": {
            "id": -149264887,
            "latitude": 57.389226,
            "longitude": 63.749486,
            "index": 341,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_1140093746": {
            "id": 1140093746,
            "latitude": 57.390642,
            "longitude": 63.748363,
            "index": 342,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149264922": {
            "id": -149264922,
            "latitude": 57.392163,
            "longitude": 63.747142,
            "index": 343,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149264958": {
            "id": -149264958,
            "latitude": 57.39275,
            "longitude": 63.746675,
            "index": 344,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149262328": {
            "id": -149262328,
            "latitude": 57.392884,
            "longitude": 63.746583,
            "index": 345,
            "is_stop": 0,
            "segment_id": -149262329,
            "segment_index": 46
        },
        "point_-149265534": {
            "id": -149265534,
            "latitude": 57.393078,
            "longitude": 63.746428,
            "index": 347,
            "is_stop": 0,
            "segment_id": -149265535,
            "segment_index": 47
        },
        "point_-149271197": {
            "id": -149271197,
            "latitude": 57.393765,
            "longitude": 63.745912,
            "index": 349,
            "is_stop": 0,
            "segment_id": -149270754,
            "segment_index": 48
        },
        "point_-149271217": {
            "id": -149271217,
            "latitude": 57.394317,
            "longitude": 63.745436,
            "index": 350,
            "is_stop": 0,
            "segment_id": -149270754,
            "segment_index": 48
        },
        "point_-149271460": {
            "id": -149271460,
            "latitude": 57.394749,
            "longitude": 63.744978,
            "index": 351,
            "is_stop": 0,
            "segment_id": -149270754,
            "segment_index": 48
        },
        "point_-149271704": {
            "id": -149271704,
            "latitude": 57.395153,
            "longitude": 63.744484,
            "index": 352,
            "is_stop": 0,
            "segment_id": -149270754,
            "segment_index": 48
        },
        "point_-149271949": {
            "id": -149271949,
            "latitude": 57.395454,
            "longitude": 63.744101,
            "index": 353,
            "is_stop": 0,
            "segment_id": -149270754,
            "segment_index": 48
        },
        "point_-149272667": {
            "id": -149272667,
            "latitude": 57.397229,
            "longitude": 63.7419,
            "index": 354,
            "is_stop": 0,
            "segment_id": -149270754,
            "segment_index": 48
        },
        "point_-149272916": {
            "id": -149272916,
            "latitude": 57.398454,
            "longitude": 63.740444,
            "index": 355,
            "is_stop": 0,
            "segment_id": -149270754,
            "segment_index": 48
        },
        "point_-221917901": {
            "id": -221917901,
            "latitude": 57.401634,
            "longitude": 63.73661,
            "index": 356,
            "is_stop": 0,
            "segment_id": -149270754,
            "segment_index": 48
        },
        "point_-221927991": {
            "id": -221927991,
            "latitude": 57.401584,
            "longitude": 63.736493,
            "index": 358,
            "is_stop": 0,
            "segment_id": -221928369,
            "segment_index": 49
        },
        "point_1138719918": {
            "id": 1138719918,
            "latitude": 57.401389,
            "longitude": 63.735685,
            "index": 360,
            "is_stop": 0,
            "segment_id": -221928392,
            "segment_index": 50
        },
        "point_1138719424": {
            "id": 1138719424,
            "latitude": 57.398652,
            "longitude": 63.723351,
            "index": 361,
            "is_stop": 0,
            "segment_id": -221928392,
            "segment_index": 50
        },
        "point_1138719064": {
            "id": 1138719064,
            "latitude": 57.396536,
            "longitude": 63.713878,
            "index": 362,
            "is_stop": 0,
            "segment_id": -221928392,
            "segment_index": 50
        },
        "point_-224498862": {
            "id": -224498862,
            "latitude": 57.39411,
            "longitude": 63.702964,
            "index": 363,
            "is_stop": 0,
            "segment_id": -221928392,
            "segment_index": 50
        },
        "point_-224499049": {
            "id": -224499049,
            "latitude": 57.394018,
            "longitude": 63.702587,
            "index": 365,
            "is_stop": 0,
            "segment_id": -224499288,
            "segment_index": 51
        },
        "point_1138718799": {
            "id": 1138718799,
            "latitude": 57.393257,
            "longitude": 63.699091,
            "index": 367,
            "is_stop": 0,
            "segment_id": -224499105,
            "segment_index": 52
        },
        "point_1138718097": {
            "id": 1138718097,
            "latitude": 57.392734,
            "longitude": 63.696454,
            "index": 368,
            "is_stop": 0,
            "segment_id": -224499105,
            "segment_index": 52
        },
        "point_1138718233": {
            "id": 1138718233,
            "latitude": 57.392396,
            "longitude": 63.694501,
            "index": 369,
            "is_stop": 0,
            "segment_id": -224499105,
            "segment_index": 52
        },
        "point_-224499574": {
            "id": -224499574,
            "latitude": 57.392169,
            "longitude": 63.693105,
            "index": 370,
            "is_stop": 0,
            "segment_id": -224499105,
            "segment_index": 52
        },
        "point_-224499406": {
            "id": -224499406,
            "latitude": 57.392079,
            "longitude": 63.692619,
            "index": 372,
            "is_stop": 0,
            "segment_id": -224499732,
            "segment_index": 53
        },
        "point_1138709760": {
            "id": 1138709760,
            "latitude": 57.391849,
            "longitude": 63.691495,
            "index": 374,
            "is_stop": 0,
            "segment_id": -224499490,
            "segment_index": 54
        },
        "point_1138701061": {
            "id": 1138701061,
            "latitude": 57.388805,
            "longitude": 63.673862,
            "index": 375,
            "is_stop": 0,
            "segment_id": -224499490,
            "segment_index": 54
        },
        "point_1138708815": {
            "id": 1138708815,
            "latitude": 57.388428,
            "longitude": 63.671507,
            "index": 376,
            "is_stop": 0,
            "segment_id": -224499490,
            "segment_index": 54
        },
        "point_-221929217": {
            "id": -221929217,
            "latitude": 57.388079,
            "longitude": 63.669152,
            "index": 377,
            "is_stop": 0,
            "segment_id": -224499490,
            "segment_index": 54
        },
        "point_1138668205": {
            "id": 1138668205,
            "latitude": 57.387849,
            "longitude": 63.66732,
            "index": 379,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138677658": {
            "id": 1138677658,
            "latitude": 57.387714,
            "longitude": 63.665626,
            "index": 380,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-221992551": {
            "id": -221992551,
            "latitude": 57.387614,
            "longitude": 63.663931,
            "index": 381,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138657869": {
            "id": 1138657869,
            "latitude": 57.387517,
            "longitude": 63.661474,
            "index": 382,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-221986193": {
            "id": -221986193,
            "latitude": 57.387497,
            "longitude": 63.658227,
            "index": 383,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138635532": {
            "id": 1138635532,
            "latitude": 57.387492,
            "longitude": 63.655848,
            "index": 384,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138620006": {
            "id": 1138620006,
            "latitude": 57.387522,
            "longitude": 63.653448,
            "index": 385,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138605953": {
            "id": 1138605953,
            "latitude": 57.388078,
            "longitude": 63.628232,
            "index": 386,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138597130": {
            "id": 1138597130,
            "latitude": 57.388453,
            "longitude": 63.612738,
            "index": 387,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138583338": {
            "id": 1138583338,
            "latitude": 57.388799,
            "longitude": 63.594938,
            "index": 388,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138570561": {
            "id": 1138570561,
            "latitude": 57.389072,
            "longitude": 63.578602,
            "index": 389,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-221979936": {
            "id": -221979936,
            "latitude": 57.389316,
            "longitude": 63.568044,
            "index": 390,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-224573169": {
            "id": -224573169,
            "latitude": 57.389802,
            "longitude": 63.555983,
            "index": 391,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-221958039": {
            "id": -221958039,
            "latitude": 57.390316,
            "longitude": 63.546288,
            "index": 392,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138556021": {
            "id": 1138556021,
            "latitude": 57.390445,
            "longitude": 63.545141,
            "index": 393,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138543803": {
            "id": 1138543803,
            "latitude": 57.39062,
            "longitude": 63.54392,
            "index": 394,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-224560084": {
            "id": -224560084,
            "latitude": 57.391426,
            "longitude": 63.539342,
            "index": 395,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138535441": {
            "id": 1138535441,
            "latitude": 57.391664,
            "longitude": 63.53794,
            "index": 396,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138517601": {
            "id": 1138517601,
            "latitude": 57.392311,
            "longitude": 63.534349,
            "index": 397,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138528288": {
            "id": 1138528288,
            "latitude": 57.392523,
            "longitude": 63.533322,
            "index": 398,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-221968307": {
            "id": -221968307,
            "latitude": 57.392794,
            "longitude": 63.532349,
            "index": 399,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138506953": {
            "id": 1138506953,
            "latitude": 57.393263,
            "longitude": 63.530879,
            "index": 400,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-221973959": {
            "id": -221973959,
            "latitude": 57.393818,
            "longitude": 63.529469,
            "index": 401,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138489952": {
            "id": 1138489952,
            "latitude": 57.395239,
            "longitude": 63.526314,
            "index": 402,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138495796": {
            "id": 1138495796,
            "latitude": 57.396019,
            "longitude": 63.524585,
            "index": 403,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-221962969": {
            "id": -221962969,
            "latitude": 57.396689,
            "longitude": 63.52319,
            "index": 404,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138477167": {
            "id": 1138477167,
            "latitude": 57.398128,
            "longitude": 63.520325,
            "index": 405,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138468386": {
            "id": 1138468386,
            "latitude": 57.398721,
            "longitude": 63.519262,
            "index": 406,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138463598": {
            "id": 1138463598,
            "latitude": 57.400847,
            "longitude": 63.515247,
            "index": 407,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138455587": {
            "id": 1138455587,
            "latitude": 57.403152,
            "longitude": 63.510944,
            "index": 408,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138448480": {
            "id": 1138448480,
            "latitude": 57.404782,
            "longitude": 63.507847,
            "index": 409,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138441824": {
            "id": 1138441824,
            "latitude": 57.406938,
            "longitude": 63.503779,
            "index": 410,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138432243": {
            "id": 1138432243,
            "latitude": 57.408451,
            "longitude": 63.501026,
            "index": 411,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138438077": {
            "id": 1138438077,
            "latitude": 57.409071,
            "longitude": 63.4998,
            "index": 412,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_-221949186": {
            "id": -221949186,
            "latitude": 57.409657,
            "longitude": 63.49853,
            "index": 413,
            "is_stop": 0,
            "segment_id": -221929293,
            "segment_index": 55
        },
        "point_1138388342": {
            "id": 1138388342,
            "latitude": 57.409958,
            "longitude": 63.497737,
            "index": 415,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221953417": {
            "id": -221953417,
            "latitude": 57.410236,
            "longitude": 63.496847,
            "index": 416,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138363173": {
            "id": 1138363173,
            "latitude": 57.410445,
            "longitude": 63.496095,
            "index": 417,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221941905": {
            "id": -221941905,
            "latitude": 57.410641,
            "longitude": 63.495343,
            "index": 418,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138327750": {
            "id": 1138327750,
            "latitude": 57.410739,
            "longitude": 63.49476,
            "index": 419,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138344727": {
            "id": 1138344727,
            "latitude": 57.410791,
            "longitude": 63.494361,
            "index": 420,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138291902": {
            "id": 1138291902,
            "latitude": 57.410823,
            "longitude": 63.493962,
            "index": 421,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138269918": {
            "id": 1138269918,
            "latitude": 57.410796,
            "longitude": 63.491632,
            "index": 422,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221945337": {
            "id": -221945337,
            "latitude": 57.410819,
            "longitude": 63.490979,
            "index": 423,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-224512135": {
            "id": -224512135,
            "latitude": 57.411079,
            "longitude": 63.487829,
            "index": 424,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138246859": {
            "id": 1138246859,
            "latitude": 57.41114,
            "longitude": 63.487427,
            "index": 425,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138204827": {
            "id": 1138204827,
            "latitude": 57.411216,
            "longitude": 63.487068,
            "index": 426,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138219611": {
            "id": 1138219611,
            "latitude": 57.411332,
            "longitude": 63.48651,
            "index": 427,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221934093": {
            "id": -221934093,
            "latitude": 57.411353,
            "longitude": 63.486193,
            "index": 428,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138145866": {
            "id": 1138145866,
            "latitude": 57.411309,
            "longitude": 63.485821,
            "index": 429,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138159339": {
            "id": 1138159339,
            "latitude": 57.411235,
            "longitude": 63.485447,
            "index": 430,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138173267": {
            "id": 1138173267,
            "latitude": 57.411122,
            "longitude": 63.485014,
            "index": 431,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-224525153": {
            "id": -224525153,
            "latitude": 57.411001,
            "longitude": 63.484644,
            "index": 432,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138125795": {
            "id": 1138125795,
            "latitude": 57.41081,
            "longitude": 63.484117,
            "index": 433,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221938877": {
            "id": -221938877,
            "latitude": 57.410503,
            "longitude": 63.483476,
            "index": 434,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138112711": {
            "id": 1138112711,
            "latitude": 57.410178,
            "longitude": 63.482944,
            "index": 435,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138100108": {
            "id": 1138100108,
            "latitude": 57.409805,
            "longitude": 63.482397,
            "index": 436,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138055411": {
            "id": 1138055411,
            "latitude": 57.409076,
            "longitude": 63.481441,
            "index": 437,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138066128": {
            "id": 1138066128,
            "latitude": 57.408893,
            "longitude": 63.481141,
            "index": 438,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138077312": {
            "id": 1138077312,
            "latitude": 57.408793,
            "longitude": 63.480866,
            "index": 439,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221936272": {
            "id": -221936272,
            "latitude": 57.408707,
            "longitude": 63.480515,
            "index": 440,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221930173": {
            "id": -221930173,
            "latitude": 57.408099,
            "longitude": 63.475067,
            "index": 441,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138028590": {
            "id": 1138028590,
            "latitude": 57.408107,
            "longitude": 63.474837,
            "index": 442,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138018812": {
            "id": 1138018812,
            "latitude": 57.408134,
            "longitude": 63.474608,
            "index": 443,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1138009492": {
            "id": 1138009492,
            "latitude": 57.408184,
            "longitude": 63.474364,
            "index": 444,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221931046": {
            "id": -221931046,
            "latitude": 57.408706,
            "longitude": 63.472669,
            "index": 445,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1137984555": {
            "id": 1137984555,
            "latitude": 57.408856,
            "longitude": 63.472143,
            "index": 446,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221932350": {
            "id": -221932350,
            "latitude": 57.408952,
            "longitude": 63.471483,
            "index": 447,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_1137969154": {
            "id": 1137969154,
            "latitude": 57.409287,
            "longitude": 63.46853,
            "index": 448,
            "is_stop": 0,
            "segment_id": 1138414485,
            "segment_index": 56
        },
        "point_-221929292": {
            "id": -221929292,
            "latitude": 57.409355,
            "longitude": 63.468303,
            "index": 449,
            "is_stop": 1,
            "segment_id": 1138414485,
            "segment_index": 56,
            "stop_id": "-221929292__nis",
            "stop_name": "с. Ляпуново (Байкаловский р-н)",
            "transport_type": "АВТОБУС"
        },
        "point_1137964698": {
            "id": 1137964698,
            "latitude": 57.409342,
            "longitude": 63.468033,
            "index": 451,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-224503683": {
            "id": -224503683,
            "latitude": 57.409414,
            "longitude": 63.46736,
            "index": 452,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137951583": {
            "id": 1137951583,
            "latitude": 57.409486,
            "longitude": 63.466974,
            "index": 453,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137937895": {
            "id": 1137937895,
            "latitude": 57.409592,
            "longitude": 63.466567,
            "index": 454,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137934182": {
            "id": 1137934182,
            "latitude": 57.410957,
            "longitude": 63.461106,
            "index": 455,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-224501231": {
            "id": -224501231,
            "latitude": 57.411927,
            "longitude": 63.457094,
            "index": 456,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137924668": {
            "id": 1137924668,
            "latitude": 57.41354,
            "longitude": 63.450368,
            "index": 457,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137910395": {
            "id": 1137910395,
            "latitude": 57.415084,
            "longitude": 63.443908,
            "index": 458,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137918491": {
            "id": 1137918491,
            "latitude": 57.415171,
            "longitude": 63.443564,
            "index": 459,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137907045": {
            "id": 1137907045,
            "latitude": 57.415239,
            "longitude": 63.443221,
            "index": 460,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-222000577": {
            "id": -222000577,
            "latitude": 57.415308,
            "longitude": 63.442544,
            "index": 461,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-222002510": {
            "id": -222002510,
            "latitude": 57.415671,
            "longitude": 63.436637,
            "index": 462,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137897029": {
            "id": 1137897029,
            "latitude": 57.415791,
            "longitude": 63.435481,
            "index": 463,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137903174": {
            "id": 1137903174,
            "latitude": 57.415933,
            "longitude": 63.43434,
            "index": 464,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137900042": {
            "id": 1137900042,
            "latitude": 57.416053,
            "longitude": 63.433457,
            "index": 465,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-222001767": {
            "id": -222001767,
            "latitude": 57.416212,
            "longitude": 63.432603,
            "index": 466,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137890007": {
            "id": 1137890007,
            "latitude": 57.416505,
            "longitude": 63.431352,
            "index": 467,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137887211": {
            "id": 1137887211,
            "latitude": 57.416804,
            "longitude": 63.430381,
            "index": 468,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-222001124": {
            "id": -222001124,
            "latitude": 57.417223,
            "longitude": 63.429404,
            "index": 469,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137880709": {
            "id": 1137880709,
            "latitude": 57.417833,
            "longitude": 63.428334,
            "index": 470,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137876214": {
            "id": 1137876214,
            "latitude": 57.418472,
            "longitude": 63.427415,
            "index": 471,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137872366": {
            "id": 1137872366,
            "latitude": 57.420496,
            "longitude": 63.424704,
            "index": 472,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137866717": {
            "id": 1137866717,
            "latitude": 57.423751,
            "longitude": 63.420284,
            "index": 473,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137868785": {
            "id": 1137868785,
            "latitude": 57.424676,
            "longitude": 63.419003,
            "index": 474,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-222000117": {
            "id": -222000117,
            "latitude": 57.425057,
            "longitude": 63.418537,
            "index": 475,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137862135": {
            "id": 1137862135,
            "latitude": 57.425432,
            "longitude": 63.418107,
            "index": 476,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137858030": {
            "id": 1137858030,
            "latitude": 57.426243,
            "longitude": 63.417259,
            "index": 477,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137855440": {
            "id": 1137855440,
            "latitude": 57.427358,
            "longitude": 63.416249,
            "index": 478,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-224612071": {
            "id": -224612071,
            "latitude": 57.429679,
            "longitude": 63.414203,
            "index": 479,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137851998": {
            "id": 1137851998,
            "latitude": 57.430534,
            "longitude": 63.41344,
            "index": 480,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_1137849873": {
            "id": 1137849873,
            "latitude": 57.431544,
            "longitude": 63.412569,
            "index": 481,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-221999799": {
            "id": -221999799,
            "latitude": 57.434128,
            "longitude": 63.410336,
            "index": 482,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-224597965": {
            "id": -224597965,
            "latitude": 57.436531,
            "longitude": 63.40823,
            "index": 483,
            "is_stop": 0,
            "segment_id": -221999477,
            "segment_index": 57
        },
        "point_-224589907": {
            "id": -224589907,
            "latitude": 57.436757,
            "longitude": 63.408043,
            "index": 485,
            "is_stop": 0,
            "segment_id": -224611863,
            "segment_index": 58
        },
        "point_1137830592": {
            "id": 1137830592,
            "latitude": 57.438511,
            "longitude": 63.406479,
            "index": 487,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222046588": {
            "id": -222046588,
            "latitude": 57.440168,
            "longitude": 63.404915,
            "index": 488,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137802583": {
            "id": 1137802583,
            "latitude": 57.441002,
            "longitude": 63.404117,
            "index": 489,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-224623164": {
            "id": -224623164,
            "latitude": 57.441703,
            "longitude": 63.403329,
            "index": 490,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137765953": {
            "id": 1137765953,
            "latitude": 57.442236,
            "longitude": 63.40257,
            "index": 491,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-224615091": {
            "id": -224615091,
            "latitude": 57.442671,
            "longitude": 63.401812,
            "index": 492,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137739275": {
            "id": 1137739275,
            "latitude": 57.443111,
            "longitude": 63.400922,
            "index": 493,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222052262": {
            "id": -222052262,
            "latitude": 57.443482,
            "longitude": 63.39999,
            "index": 494,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137696673": {
            "id": 1137696673,
            "latitude": 57.443728,
            "longitude": 63.399209,
            "index": 495,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137713065": {
            "id": 1137713065,
            "latitude": 57.443999,
            "longitude": 63.398142,
            "index": 496,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137671279": {
            "id": 1137671279,
            "latitude": 57.444714,
            "longitude": 63.394693,
            "index": 497,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137639097": {
            "id": 1137639097,
            "latitude": 57.446771,
            "longitude": 63.384343,
            "index": 498,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137655087": {
            "id": 1137655087,
            "latitude": 57.447138,
            "longitude": 63.38248,
            "index": 499,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222064029": {
            "id": -222064029,
            "latitude": 57.447668,
            "longitude": 63.380005,
            "index": 500,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137614208": {
            "id": 1137614208,
            "latitude": 57.447941,
            "longitude": 63.378968,
            "index": 501,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137575634": {
            "id": 1137575634,
            "latitude": 57.448567,
            "longitude": 63.376853,
            "index": 502,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137537938": {
            "id": 1137537938,
            "latitude": 57.449848,
            "longitude": 63.372869,
            "index": 503,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137560117": {
            "id": 1137560117,
            "latitude": 57.450316,
            "longitude": 63.371277,
            "index": 504,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222058093": {
            "id": -222058093,
            "latitude": 57.450756,
            "longitude": 63.369685,
            "index": 505,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137488738": {
            "id": 1137488738,
            "latitude": 57.451077,
            "longitude": 63.368306,
            "index": 506,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137503614": {
            "id": 1137503614,
            "latitude": 57.451452,
            "longitude": 63.366457,
            "index": 507,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137473563": {
            "id": 1137473563,
            "latitude": 57.451826,
            "longitude": 63.364437,
            "index": 508,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137447918": {
            "id": 1137447918,
            "latitude": 57.453282,
            "longitude": 63.357001,
            "index": 509,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137428466": {
            "id": 1137428466,
            "latitude": 57.45358,
            "longitude": 63.35576,
            "index": 510,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222041009": {
            "id": -222041009,
            "latitude": 57.453811,
            "longitude": 63.354961,
            "index": 511,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137414400": {
            "id": 1137414400,
            "latitude": 57.454233,
            "longitude": 63.353875,
            "index": 512,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137394378": {
            "id": 1137394378,
            "latitude": 57.45496,
            "longitude": 63.352468,
            "index": 513,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137371019": {
            "id": 1137371019,
            "latitude": 57.457712,
            "longitude": 63.347645,
            "index": 514,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-224638487": {
            "id": -224638487,
            "latitude": 57.463434,
            "longitude": 63.337706,
            "index": 515,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137353317": {
            "id": 1137353317,
            "latitude": 57.465515,
            "longitude": 63.334046,
            "index": 516,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137336191": {
            "id": 1137336191,
            "latitude": 57.472804,
            "longitude": 63.321279,
            "index": 517,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137319471": {
            "id": 1137319471,
            "latitude": 57.476095,
            "longitude": 63.315538,
            "index": 518,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222035652": {
            "id": -222035652,
            "latitude": 57.477174,
            "longitude": 63.31361,
            "index": 519,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137286882": {
            "id": 1137286882,
            "latitude": 57.477539,
            "longitude": 63.312813,
            "index": 520,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137298932": {
            "id": 1137298932,
            "latitude": 57.477823,
            "longitude": 63.312033,
            "index": 521,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137271110": {
            "id": 1137271110,
            "latitude": 57.478182,
            "longitude": 63.310782,
            "index": 522,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137256219": {
            "id": 1137256219,
            "latitude": 57.479086,
            "longitude": 63.306779,
            "index": 523,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222070066": {
            "id": -222070066,
            "latitude": 57.480113,
            "longitude": 63.302254,
            "index": 524,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137234381": {
            "id": 1137234381,
            "latitude": 57.480391,
            "longitude": 63.301464,
            "index": 525,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137245134": {
            "id": 1137245134,
            "latitude": 57.480765,
            "longitude": 63.300774,
            "index": 526,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137216495": {
            "id": 1137216495,
            "latitude": 57.48112,
            "longitude": 63.300212,
            "index": 527,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137187059": {
            "id": 1137187059,
            "latitude": 57.483119,
            "longitude": 63.297571,
            "index": 528,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137203128": {
            "id": 1137203128,
            "latitude": 57.484074,
            "longitude": 63.29622,
            "index": 529,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137174522": {
            "id": 1137174522,
            "latitude": 57.485179,
            "longitude": 63.29476,
            "index": 530,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137162356": {
            "id": 1137162356,
            "latitude": 57.487668,
            "longitude": 63.291428,
            "index": 531,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222076595": {
            "id": -222076595,
            "latitude": 57.489803,
            "longitude": 63.28858,
            "index": 532,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137153578": {
            "id": 1137153578,
            "latitude": 57.490533,
            "longitude": 63.287578,
            "index": 533,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-224653788": {
            "id": -224653788,
            "latitude": 57.491176,
            "longitude": 63.286843,
            "index": 534,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137134946": {
            "id": 1137134946,
            "latitude": 57.491546,
            "longitude": 63.286509,
            "index": 535,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137142954": {
            "id": 1137142954,
            "latitude": 57.491945,
            "longitude": 63.286223,
            "index": 536,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222098325": {
            "id": -222098325,
            "latitude": 57.492252,
            "longitude": 63.286067,
            "index": 537,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137121647": {
            "id": 1137121647,
            "latitude": 57.49272,
            "longitude": 63.285861,
            "index": 538,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137114226": {
            "id": 1137114226,
            "latitude": 57.493861,
            "longitude": 63.285424,
            "index": 539,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137098172": {
            "id": 1137098172,
            "latitude": 57.49627,
            "longitude": 63.284575,
            "index": 540,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137105951": {
            "id": 1137105951,
            "latitude": 57.497356,
            "longitude": 63.284186,
            "index": 541,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137083066": {
            "id": 1137083066,
            "latitude": 57.498516,
            "longitude": 63.28373,
            "index": 542,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137089804": {
            "id": 1137089804,
            "latitude": 57.499292,
            "longitude": 63.283344,
            "index": 543,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222090650": {
            "id": -222090650,
            "latitude": 57.500017,
            "longitude": 63.282958,
            "index": 544,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137076199": {
            "id": 1137076199,
            "latitude": 57.501076,
            "longitude": 63.282308,
            "index": 545,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137070330": {
            "id": 1137070330,
            "latitude": 57.501908,
            "longitude": 63.28162,
            "index": 546,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-224663820": {
            "id": -224663820,
            "latitude": 57.503117,
            "longitude": 63.280536,
            "index": 547,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137065105": {
            "id": 1137065105,
            "latitude": 57.504283,
            "longitude": 63.279296,
            "index": 548,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_-222083362": {
            "id": -222083362,
            "latitude": 57.505345,
            "longitude": 63.278039,
            "index": 549,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137059559": {
            "id": 1137059559,
            "latitude": 57.506764,
            "longitude": 63.276101,
            "index": 550,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1137007192": {
            "id": 1137007192,
            "latitude": 57.508394,
            "longitude": 63.273782,
            "index": 551,
            "is_stop": 0,
            "segment_id": -224599289,
            "segment_index": 59
        },
        "point_1136980740": {
            "id": 1136980740,
            "latitude": 57.5116,
            "longitude": 63.269291,
            "index": 553,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136953045": {
            "id": 1136953045,
            "latitude": 57.51324,
            "longitude": 63.266945,
            "index": 554,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136895011": {
            "id": 1136895011,
            "latitude": 57.516507,
            "longitude": 63.262407,
            "index": 555,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136923678": {
            "id": 1136923678,
            "latitude": 57.517406,
            "longitude": 63.261136,
            "index": 556,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222025732": {
            "id": -222025732,
            "latitude": 57.518341,
            "longitude": 63.260026,
            "index": 557,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136866189": {
            "id": 1136866189,
            "latitude": 57.5192,
            "longitude": 63.259253,
            "index": 558,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222030483": {
            "id": -222030483,
            "latitude": 57.521201,
            "longitude": 63.257601,
            "index": 559,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136811915": {
            "id": 1136811915,
            "latitude": 57.521884,
            "longitude": 63.256908,
            "index": 560,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136838649": {
            "id": 1136838649,
            "latitude": 57.522346,
            "longitude": 63.256377,
            "index": 561,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136788866": {
            "id": 1136788866,
            "latitude": 57.522773,
            "longitude": 63.255771,
            "index": 562,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136766792": {
            "id": 1136766792,
            "latitude": 57.526438,
            "longitude": 63.250488,
            "index": 563,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136741360": {
            "id": 1136741360,
            "latitude": 57.529132,
            "longitude": 63.246522,
            "index": 564,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222011283": {
            "id": -222011283,
            "latitude": 57.530423,
            "longitude": 63.244622,
            "index": 565,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136716852": {
            "id": 1136716852,
            "latitude": 57.530868,
            "longitude": 63.24398,
            "index": 566,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136668265": {
            "id": 1136668265,
            "latitude": 57.531317,
            "longitude": 63.243397,
            "index": 567,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222014195": {
            "id": -222014195,
            "latitude": 57.531856,
            "longitude": 63.242766,
            "index": 568,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136692189": {
            "id": 1136692189,
            "latitude": 57.532337,
            "longitude": 63.24229,
            "index": 569,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222017568": {
            "id": -222017568,
            "latitude": 57.533053,
            "longitude": 63.241748,
            "index": 570,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136648923": {
            "id": 1136648923,
            "latitude": 57.533402,
            "longitude": 63.241539,
            "index": 571,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136622852": {
            "id": 1136622852,
            "latitude": 57.533777,
            "longitude": 63.241346,
            "index": 572,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136587224": {
            "id": 1136587224,
            "latitude": 57.534813,
            "longitude": 63.240906,
            "index": 573,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136604753": {
            "id": 1136604753,
            "latitude": 57.535355,
            "longitude": 63.240664,
            "index": 574,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222021414": {
            "id": -222021414,
            "latitude": 57.535742,
            "longitude": 63.240439,
            "index": 575,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136567054": {
            "id": 1136567054,
            "latitude": 57.536032,
            "longitude": 63.24019,
            "index": 576,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222006865": {
            "id": -222006865,
            "latitude": 57.536268,
            "longitude": 63.239931,
            "index": 577,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136546668": {
            "id": 1136546668,
            "latitude": 57.536614,
            "longitude": 63.239408,
            "index": 578,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136523838": {
            "id": 1136523838,
            "latitude": 57.537032,
            "longitude": 63.238612,
            "index": 579,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136487912": {
            "id": 1136487912,
            "latitude": 57.537832,
            "longitude": 63.236818,
            "index": 580,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136505559": {
            "id": 1136505559,
            "latitude": 57.538254,
            "longitude": 63.235926,
            "index": 581,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136473643": {
            "id": 1136473643,
            "latitude": 57.538529,
            "longitude": 63.235399,
            "index": 582,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136457198": {
            "id": 1136457198,
            "latitude": 57.538978,
            "longitude": 63.234551,
            "index": 583,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222008832": {
            "id": -222008832,
            "latitude": 57.539408,
            "longitude": 63.233887,
            "index": 584,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136437921": {
            "id": 1136437921,
            "latitude": 57.539761,
            "longitude": 63.233432,
            "index": 585,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136422766": {
            "id": 1136422766,
            "latitude": 57.541775,
            "longitude": 63.231159,
            "index": 586,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136410756": {
            "id": 1136410756,
            "latitude": 57.543516,
            "longitude": 63.229235,
            "index": 587,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222004354": {
            "id": -222004354,
            "latitude": 57.543644,
            "longitude": 63.229073,
            "index": 588,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136396196": {
            "id": 1136396196,
            "latitude": 57.543769,
            "longitude": 63.228806,
            "index": 589,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136382831": {
            "id": 1136382831,
            "latitude": 57.544059,
            "longitude": 63.227876,
            "index": 590,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136367179": {
            "id": 1136367179,
            "latitude": 57.544166,
            "longitude": 63.227605,
            "index": 591,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222005359": {
            "id": -222005359,
            "latitude": 57.54431,
            "longitude": 63.227351,
            "index": 592,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_1136356860": {
            "id": 1136356860,
            "latitude": 57.54444,
            "longitude": 63.227167,
            "index": 593,
            "is_stop": 0,
            "segment_id": 1137033407,
            "segment_index": 60
        },
        "point_-222003346": {
            "id": -222003346,
            "latitude": 57.544905,
            "longitude": 63.226567,
            "index": 594,
            "is_stop": 1,
            "segment_id": 1137033407,
            "segment_index": 60,
            "stop_id": "-222003346__nis",
            "stop_name": "с. Знаменское (Ирбитское МО)",
            "transport_type": "АВТОБУС"
        },
        "point_1136353858": {
            "id": 1136353858,
            "latitude": 57.545217,
            "longitude": 63.226075,
            "index": 596,
            "is_stop": 0,
            "segment_id": -222106370,
            "segment_index": 61
        },
        "point_1136352703": {
            "id": 1136352703,
            "latitude": 57.54546,
            "longitude": 63.225636,
            "index": 597,
            "is_stop": 0,
            "segment_id": -222106370,
            "segment_index": 61
        },
        "point_1136351531": {
            "id": 1136351531,
            "latitude": 57.546413,
            "longitude": 63.22443,
            "index": 598,
            "is_stop": 0,
            "segment_id": -222106370,
            "segment_index": 61
        },
        "point_1136351437": {
            "id": 1136351437,
            "latitude": 57.547879,
            "longitude": 63.222517,
            "index": 599,
            "is_stop": 0,
            "segment_id": -222106370,
            "segment_index": 61
        },
        "point_-222106414": {
            "id": -222106414,
            "latitude": 57.548798,
            "longitude": 63.221261,
            "index": 600,
            "is_stop": 0,
            "segment_id": -222106370,
            "segment_index": 61
        },
        "point_-91375082": {
            "id": -91375082,
            "latitude": 57.549982,
            "longitude": 63.219166,
            "index": 601,
            "is_stop": 0,
            "segment_id": -222106370,
            "segment_index": 61
        },
        "point_1136345460": {
            "id": 1136345460,
            "latitude": 57.552455,
            "longitude": 63.214828,
            "index": 603,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91375471": {
            "id": -91375471,
            "latitude": 57.554101,
            "longitude": 63.211998,
            "index": 604,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91375808": {
            "id": -91375808,
            "latitude": 57.555782,
            "longitude": 63.208686,
            "index": 605,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-224694752": {
            "id": -224694752,
            "latitude": 57.556576,
            "longitude": 63.207082,
            "index": 606,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136338974": {
            "id": 1136338974,
            "latitude": 57.557035,
            "longitude": 63.206111,
            "index": 607,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91376064": {
            "id": -91376064,
            "latitude": 57.557384,
            "longitude": 63.205237,
            "index": 608,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136332455": {
            "id": 1136332455,
            "latitude": 57.557658,
            "longitude": 63.204454,
            "index": 609,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136334989": {
            "id": 1136334989,
            "latitude": 57.558243,
            "longitude": 63.202525,
            "index": 610,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136326727": {
            "id": 1136326727,
            "latitude": 57.558799,
            "longitude": 63.200607,
            "index": 611,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136330312": {
            "id": 1136330312,
            "latitude": 57.559565,
            "longitude": 63.197936,
            "index": 612,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91375292": {
            "id": -91375292,
            "latitude": 57.560209,
            "longitude": 63.19593,
            "index": 613,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136324756": {
            "id": 1136324756,
            "latitude": 57.560367,
            "longitude": 63.195475,
            "index": 614,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-224696595": {
            "id": -224696595,
            "latitude": 57.560537,
            "longitude": 63.195117,
            "index": 615,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136321008": {
            "id": 1136321008,
            "latitude": 57.560823,
            "longitude": 63.194612,
            "index": 616,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136317968": {
            "id": 1136317968,
            "latitude": 57.561729,
            "longitude": 63.193174,
            "index": 617,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136315088": {
            "id": 1136315088,
            "latitude": 57.562289,
            "longitude": 63.192267,
            "index": 618,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91376497": {
            "id": -91376497,
            "latitude": 57.562585,
            "longitude": 63.191691,
            "index": 619,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136311993": {
            "id": 1136311993,
            "latitude": 57.563586,
            "longitude": 63.189408,
            "index": 620,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91376919": {
            "id": -91376919,
            "latitude": 57.56494,
            "longitude": 63.186554,
            "index": 621,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91377446": {
            "id": -91377446,
            "latitude": 57.566562,
            "longitude": 63.183294,
            "index": 622,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91378091": {
            "id": -91378091,
            "latitude": 57.567431,
            "longitude": 63.181532,
            "index": 623,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91378861": {
            "id": -91378861,
            "latitude": 57.567657,
            "longitude": 63.181136,
            "index": 624,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136308169": {
            "id": 1136308169,
            "latitude": 57.567908,
            "longitude": 63.18084,
            "index": 625,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136306851": {
            "id": 1136306851,
            "latitude": 57.568205,
            "longitude": 63.180571,
            "index": 626,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_1136302017": {
            "id": 1136302017,
            "latitude": 57.569178,
            "longitude": 63.179819,
            "index": 627,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-91375171": {
            "id": -91375171,
            "latitude": 57.570332,
            "longitude": 63.179008,
            "index": 628,
            "is_stop": 0,
            "segment_id": -91375172,
            "segment_index": 62
        },
        "point_-222107051": {
            "id": -222107051,
            "latitude": 57.570458,
            "longitude": 63.179018,
            "index": 630,
            "is_stop": 1,
            "segment_id": -222107052,
            "segment_index": 63,
            "stop_id": "-222107051__nis",
            "stop_name": "пов. д. Новгородова (Ирбитское МО)",
            "transport_type": "АВТОБУС"
        },
        "point_-222106486": {
            "id": -222106486,
            "latitude": 57.570532,
            "longitude": 63.178853,
            "index": 632,
            "is_stop": 0,
            "segment_id": -222107077,
            "segment_index": 64
        },
        "point_1136301095": {
            "id": 1136301095,
            "latitude": 57.572862,
            "longitude": 63.177122,
            "index": 634,
            "is_stop": 0,
            "segment_id": -222106612,
            "segment_index": 65
        },
        "point_-91379941": {
            "id": -91379941,
            "latitude": 57.573141,
            "longitude": 63.17698,
            "index": 635,
            "is_stop": 0,
            "segment_id": -222106612,
            "segment_index": 65
        },
        "point_1136300481": {
            "id": 1136300481,
            "latitude": 57.573432,
            "longitude": 63.176879,
            "index": 636,
            "is_stop": 0,
            "segment_id": -222106612,
            "segment_index": 65
        },
        "point_-91380019": {
            "id": -91380019,
            "latitude": 57.574211,
            "longitude": 63.176746,
            "index": 637,
            "is_stop": 0,
            "segment_id": -222106612,
            "segment_index": 65
        },
        "point_1136300208": {
            "id": 1136300208,
            "latitude": 57.575277,
            "longitude": 63.176671,
            "index": 638,
            "is_stop": 0,
            "segment_id": -222106612,
            "segment_index": 65
        },
        "point_1136299955": {
            "id": 1136299955,
            "latitude": 57.576662,
            "longitude": 63.176574,
            "index": 639,
            "is_stop": 0,
            "segment_id": -222106612,
            "segment_index": 65
        },
        "point_1136299716": {
            "id": 1136299716,
            "latitude": 57.581604,
            "longitude": 63.176271,
            "index": 640,
            "is_stop": 0,
            "segment_id": -222106612,
            "segment_index": 65
        },
        "point_-91379888": {
            "id": -91379888,
            "latitude": 57.583215,
            "longitude": 63.176181,
            "index": 641,
            "is_stop": 0,
            "segment_id": -222106612,
            "segment_index": 65
        },
        "point_-91380125": {
            "id": -91380125,
            "latitude": 57.583328,
            "longitude": 63.176234,
            "index": 643,
            "is_stop": 1,
            "segment_id": -91380126,
            "segment_index": 66,
            "stop_id": "-91380125__nis",
            "stop_name": "пов. д. Березовка (Ирбитское МО)",
            "transport_type": "АВТОБУС"
        },
        "point_-224673893": {
            "id": -224673893,
            "latitude": 57.58342,
            "longitude": 63.176179,
            "index": 645,
            "is_stop": 0,
            "segment_id": -91380235,
            "segment_index": 67
        },
        "point_1136295953": {
            "id": 1136295953,
            "latitude": 57.586032,
            "longitude": 63.176008,
            "index": 647,
            "is_stop": 0,
            "segment_id": -224673945,
            "segment_index": 68
        },
        "point_1136299158": {
            "id": 1136299158,
            "latitude": 57.587764,
            "longitude": 63.175886,
            "index": 648,
            "is_stop": 0,
            "segment_id": -224673945,
            "segment_index": 68
        },
        "point_1136292911": {
            "id": 1136292911,
            "latitude": 57.590526,
            "longitude": 63.175758,
            "index": 649,
            "is_stop": 0,
            "segment_id": -224673945,
            "segment_index": 68
        },
        "point_-91380234": {
            "id": -91380234,
            "latitude": 57.591914,
            "longitude": 63.175642,
            "index": 650,
            "is_stop": 0,
            "segment_id": -224673945,
            "segment_index": 68
        },
        "point_1136279636": {
            "id": 1136279636,
            "latitude": 57.592283,
            "longitude": 63.175581,
            "index": 652,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136282183": {
            "id": 1136282183,
            "latitude": 57.59254,
            "longitude": 63.175479,
            "index": 653,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136271990": {
            "id": 1136271990,
            "latitude": 57.592785,
            "longitude": 63.175317,
            "index": 654,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136276899": {
            "id": 1136276899,
            "latitude": 57.593285,
            "longitude": 63.174913,
            "index": 655,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136269324": {
            "id": 1136269324,
            "latitude": 57.593757,
            "longitude": 63.174499,
            "index": 656,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91394574": {
            "id": -91394574,
            "latitude": 57.59418,
            "longitude": 63.174241,
            "index": 657,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136262201": {
            "id": 1136262201,
            "latitude": 57.59463,
            "longitude": 63.174034,
            "index": 658,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91395446": {
            "id": -91395446,
            "latitude": 57.595966,
            "longitude": 63.173486,
            "index": 659,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136257318": {
            "id": 1136257318,
            "latitude": 57.596904,
            "longitude": 63.172986,
            "index": 660,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136252990": {
            "id": 1136252990,
            "latitude": 57.597401,
            "longitude": 63.172687,
            "index": 661,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136248781": {
            "id": 1136248781,
            "latitude": 57.597774,
            "longitude": 63.17239,
            "index": 662,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91392952": {
            "id": -91392952,
            "latitude": 57.598095,
            "longitude": 63.172028,
            "index": 663,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91393745": {
            "id": -91393745,
            "latitude": 57.599832,
            "longitude": 63.169828,
            "index": 664,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136246305": {
            "id": 1136246305,
            "latitude": 57.60035,
            "longitude": 63.169213,
            "index": 665,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-224675163": {
            "id": -224675163,
            "latitude": 57.600876,
            "longitude": 63.168658,
            "index": 666,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136238471": {
            "id": 1136238471,
            "latitude": 57.601112,
            "longitude": 63.168458,
            "index": 667,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91392218": {
            "id": -91392218,
            "latitude": 57.601295,
            "longitude": 63.168369,
            "index": 668,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136236402": {
            "id": 1136236402,
            "latitude": 57.601569,
            "longitude": 63.168288,
            "index": 669,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91391534": {
            "id": -91391534,
            "latitude": 57.601909,
            "longitude": 63.168314,
            "index": 670,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136232234": {
            "id": 1136232234,
            "latitude": 57.602848,
            "longitude": 63.168602,
            "index": 671,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136228696": {
            "id": 1136228696,
            "latitude": 57.605042,
            "longitude": 63.169257,
            "index": 672,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136221768": {
            "id": 1136221768,
            "latitude": 57.605512,
            "longitude": 63.169417,
            "index": 673,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136223596": {
            "id": 1136223596,
            "latitude": 57.606911,
            "longitude": 63.170016,
            "index": 674,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91390965": {
            "id": -91390965,
            "latitude": 57.607274,
            "longitude": 63.170073,
            "index": 675,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136215562": {
            "id": 1136215562,
            "latitude": 57.608359,
            "longitude": 63.170099,
            "index": 676,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136219915": {
            "id": 1136219915,
            "latitude": 57.608916,
            "longitude": 63.170111,
            "index": 677,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91390458": {
            "id": -91390458,
            "latitude": 57.60937,
            "longitude": 63.170151,
            "index": 678,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136212063": {
            "id": 1136212063,
            "latitude": 57.610036,
            "longitude": 63.170254,
            "index": 679,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136213595": {
            "id": 1136213595,
            "latitude": 57.611475,
            "longitude": 63.170484,
            "index": 680,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91390015": {
            "id": -91390015,
            "latitude": 57.612505,
            "longitude": 63.170554,
            "index": 681,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91389643": {
            "id": -91389643,
            "latitude": 57.613902,
            "longitude": 63.170471,
            "index": 682,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91389345": {
            "id": -91389345,
            "latitude": 57.617296,
            "longitude": 63.170252,
            "index": 683,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136206211": {
            "id": 1136206211,
            "latitude": 57.617669,
            "longitude": 63.170268,
            "index": 684,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91389115": {
            "id": -91389115,
            "latitude": 57.617906,
            "longitude": 63.170336,
            "index": 685,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136207589": {
            "id": 1136207589,
            "latitude": 57.618117,
            "longitude": 63.170476,
            "index": 686,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1136208959": {
            "id": 1136208959,
            "latitude": 57.618306,
            "longitude": 63.170664,
            "index": 687,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91388959": {
            "id": -91388959,
            "latitude": 57.618493,
            "longitude": 63.170895,
            "index": 688,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1129778829": {
            "id": 1129778829,
            "latitude": 57.618876,
            "longitude": 63.171523,
            "index": 689,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_1129782341": {
            "id": 1129782341,
            "latitude": 57.619533,
            "longitude": 63.172557,
            "index": 690,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91284752": {
            "id": -91284752,
            "latitude": 57.619735,
            "longitude": 63.172873,
            "index": 691,
            "is_stop": 0,
            "segment_id": -91388877,
            "segment_index": 69
        },
        "point_-91278823": {
            "id": -91278823,
            "latitude": 57.619794,
            "longitude": 63.172967,
            "index": 693,
            "is_stop": 0,
            "segment_id": -91396368,
            "segment_index": 70
        },
        "point_-91278711": {
            "id": -91278711,
            "latitude": 57.61983,
            "longitude": 63.172821,
            "index": 695,
            "is_stop": 0,
            "segment_id": -91292540,
            "segment_index": 71
        },
        "point_1129783871": {
            "id": 1129783871,
            "latitude": 57.620198,
            "longitude": 63.171539,
            "index": 697,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91278950": {
            "id": -91278950,
            "latitude": 57.620653,
            "longitude": 63.170161,
            "index": 698,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129785810": {
            "id": 1129785810,
            "latitude": 57.62106,
            "longitude": 63.169042,
            "index": 699,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91279103": {
            "id": -91279103,
            "latitude": 57.621442,
            "longitude": 63.168077,
            "index": 700,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129788088": {
            "id": 1129788088,
            "latitude": 57.621787,
            "longitude": 63.167233,
            "index": 701,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91279517": {
            "id": -91279517,
            "latitude": 57.622147,
            "longitude": 63.16641,
            "index": 702,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91279289": {
            "id": -91279289,
            "latitude": 57.62268,
            "longitude": 63.165262,
            "index": 703,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129791474": {
            "id": 1129791474,
            "latitude": 57.623128,
            "longitude": 63.164426,
            "index": 704,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91279785": {
            "id": -91279785,
            "latitude": 57.623809,
            "longitude": 63.163242,
            "index": 705,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129793887": {
            "id": 1129793887,
            "latitude": 57.624349,
            "longitude": 63.16237,
            "index": 706,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91280103": {
            "id": -91280103,
            "latitude": 57.625139,
            "longitude": 63.161192,
            "index": 707,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129795093": {
            "id": 1129795093,
            "latitude": 57.626026,
            "longitude": 63.160028,
            "index": 708,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91280480": {
            "id": -91280480,
            "latitude": 57.626776,
            "longitude": 63.159119,
            "index": 709,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91280923": {
            "id": -91280923,
            "latitude": 57.628032,
            "longitude": 63.157576,
            "index": 710,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129799266": {
            "id": 1129799266,
            "latitude": 57.629193,
            "longitude": 63.156142,
            "index": 711,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91281439": {
            "id": -91281439,
            "latitude": 57.630067,
            "longitude": 63.155061,
            "index": 712,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91282039": {
            "id": -91282039,
            "latitude": 57.631474,
            "longitude": 63.15336,
            "index": 713,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129805466": {
            "id": 1129805466,
            "latitude": 57.632336,
            "longitude": 63.152257,
            "index": 714,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129807036": {
            "id": 1129807036,
            "latitude": 57.63284,
            "longitude": 63.151567,
            "index": 715,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91282731": {
            "id": -91282731,
            "latitude": 57.633302,
            "longitude": 63.150903,
            "index": 716,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129810102": {
            "id": 1129810102,
            "latitude": 57.633716,
            "longitude": 63.150262,
            "index": 717,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129813412": {
            "id": 1129813412,
            "latitude": 57.634056,
            "longitude": 63.14967,
            "index": 718,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91283522": {
            "id": -91283522,
            "latitude": 57.63439,
            "longitude": 63.149104,
            "index": 719,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129815095": {
            "id": 1129815095,
            "latitude": 57.634823,
            "longitude": 63.148318,
            "index": 720,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129817032": {
            "id": 1129817032,
            "latitude": 57.635195,
            "longitude": 63.14763,
            "index": 721,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_-91278607": {
            "id": -91278607,
            "latitude": 57.635535,
            "longitude": 63.146947,
            "index": 722,
            "is_stop": 0,
            "segment_id": -91290966,
            "segment_index": 72
        },
        "point_1129820531": {
            "id": 1129820531,
            "latitude": 57.636654,
            "longitude": 63.144533,
            "index": 724,
            "is_stop": 0,
            "segment_id": -91284420,
            "segment_index": 73
        },
        "point_1129820654": {
            "id": 1129820654,
            "latitude": 57.637994,
            "longitude": 63.141616,
            "index": 725,
            "is_stop": 0,
            "segment_id": -91284420,
            "segment_index": 73
        },
        "point_-90733979": {
            "id": -90733979,
            "latitude": 57.638788,
            "longitude": 63.139926,
            "index": 726,
            "is_stop": 0,
            "segment_id": -91284420,
            "segment_index": 73
        },
        "point_-185203350": {
            "id": -185203350,
            "latitude": 57.639215,
            "longitude": 63.139009,
            "index": 728,
            "is_stop": 0,
            "segment_id": -91284600,
            "segment_index": 74
        },
        "point_-90717568": {
            "id": -90717568,
            "latitude": 57.639277,
            "longitude": 63.138889,
            "index": 730,
            "is_stop": 0,
            "segment_id": -185203394,
            "segment_index": 75
        },
        "point_1129822053": {
            "id": 1129822053,
            "latitude": 57.640358,
            "longitude": 63.136573,
            "index": 732,
            "is_stop": 0,
            "segment_id": -90717639,
            "segment_index": 76
        },
        "point_1129822269": {
            "id": 1129822269,
            "latitude": 57.642475,
            "longitude": 63.132125,
            "index": 733,
            "is_stop": 0,
            "segment_id": -90717639,
            "segment_index": 76
        },
        "point_1129822378": {
            "id": 1129822378,
            "latitude": 57.644049,
            "longitude": 63.128772,
            "index": 734,
            "is_stop": 0,
            "segment_id": -90717639,
            "segment_index": 76
        },
        "point_-90717638": {
            "id": -90717638,
            "latitude": 57.645918,
            "longitude": 63.124809,
            "index": 735,
            "is_stop": 0,
            "segment_id": -90717639,
            "segment_index": 76
        },
        "point_-90717699": {
            "id": -90717699,
            "latitude": 57.645994,
            "longitude": 63.12467,
            "index": 737,
            "is_stop": 0,
            "segment_id": -90717700,
            "segment_index": 77
        },
        "point_-90717725": {
            "id": -90717725,
            "latitude": 57.646475,
            "longitude": 63.123665,
            "index": 739,
            "is_stop": 0,
            "segment_id": -90717726,
            "segment_index": 78
        },
        "point_-90717774": {
            "id": -90717774,
            "latitude": 57.646573,
            "longitude": 63.12345,
            "index": 741,
            "is_stop": 0,
            "segment_id": -91284632,
            "segment_index": 79
        },
        "point_1129826845": {
            "id": 1129826845,
            "latitude": 57.64684,
            "longitude": 63.122853,
            "index": 743,
            "is_stop": 0,
            "segment_id": -90717798,
            "segment_index": 80
        },
        "point_1129826899": {
            "id": 1129826899,
            "latitude": 57.648764,
            "longitude": 63.11876,
            "index": 744,
            "is_stop": 0,
            "segment_id": -90717798,
            "segment_index": 80
        },
        "point_-90717797": {
            "id": -90717797,
            "latitude": 57.649747,
            "longitude": 63.11671,
            "index": 745,
            "is_stop": 0,
            "segment_id": -90717798,
            "segment_index": 80
        },
        "point_-90717918": {
            "id": -90717918,
            "latitude": 57.649907,
            "longitude": 63.116377,
            "index": 747,
            "is_stop": 0,
            "segment_id": -91284655,
            "segment_index": 81
        },
        "point_1129827522": {
            "id": 1129827522,
            "latitude": 57.651445,
            "longitude": 63.113112,
            "index": 749,
            "is_stop": 0,
            "segment_id": -90717942,
            "segment_index": 82
        },
        "point_1129827723": {
            "id": 1129827723,
            "latitude": 57.652238,
            "longitude": 63.111418,
            "index": 750,
            "is_stop": 0,
            "segment_id": -90717942,
            "segment_index": 82
        },
        "point_1129827984": {
            "id": 1129827984,
            "latitude": 57.653599,
            "longitude": 63.108553,
            "index": 751,
            "is_stop": 0,
            "segment_id": -90717942,
            "segment_index": 82
        },
        "point_-90717941": {
            "id": -90717941,
            "latitude": 57.654154,
            "longitude": 63.107362,
            "index": 752,
            "is_stop": 0,
            "segment_id": -90717942,
            "segment_index": 82
        },
        "point_-90718041": {
            "id": -90718041,
            "latitude": 57.654367,
            "longitude": 63.106921,
            "index": 754,
            "is_stop": 0,
            "segment_id": -91284678,
            "segment_index": 83
        },
        "point_1129828898": {
            "id": 1129828898,
            "latitude": 57.65526,
            "longitude": 63.105037,
            "index": 756,
            "is_stop": 0,
            "segment_id": -90718065,
            "segment_index": 84
        },
        "point_1129828984": {
            "id": 1129828984,
            "latitude": 57.655541,
            "longitude": 63.104419,
            "index": 757,
            "is_stop": 0,
            "segment_id": -90718065,
            "segment_index": 84
        },
        "point_-90718103": {
            "id": -90718103,
            "latitude": 57.655788,
            "longitude": 63.1038,
            "index": 758,
            "is_stop": 0,
            "segment_id": -90718065,
            "segment_index": 84
        },
        "point_1129829608": {
            "id": 1129829608,
            "latitude": 57.656083,
            "longitude": 63.102876,
            "index": 759,
            "is_stop": 0,
            "segment_id": -90718065,
            "segment_index": 84
        },
        "point_1129829484": {
            "id": 1129829484,
            "latitude": 57.656565,
            "longitude": 63.101192,
            "index": 760,
            "is_stop": 0,
            "segment_id": -90718065,
            "segment_index": 84
        },
        "point_-90718064": {
            "id": -90718064,
            "latitude": 57.656878,
            "longitude": 63.100231,
            "index": 761,
            "is_stop": 0,
            "segment_id": -90718065,
            "segment_index": 84
        },
        "point_-90718211": {
            "id": -90718211,
            "latitude": 57.657009,
            "longitude": 63.09988,
            "index": 763,
            "is_stop": 0,
            "segment_id": -91284701,
            "segment_index": 85
        },
        "point_-90718669": {
            "id": -90718669,
            "latitude": 57.657307,
            "longitude": 63.09914,
            "index": 765,
            "is_stop": 0,
            "segment_id": -90718250,
            "segment_index": 86
        },
        "point_1129829789": {
            "id": 1129829789,
            "latitude": 57.657596,
            "longitude": 63.098524,
            "index": 766,
            "is_stop": 0,
            "segment_id": -90718250,
            "segment_index": 86
        },
        "point_-90732609": {
            "id": -90732609,
            "latitude": 57.658104,
            "longitude": 63.097508,
            "index": 767,
            "is_stop": 0,
            "segment_id": -90718250,
            "segment_index": 86
        },
        "point_-90732243": {
            "id": -90732243,
            "latitude": 57.658993,
            "longitude": 63.095666,
            "index": 768,
            "is_stop": 0,
            "segment_id": -90718250,
            "segment_index": 86
        },
        "point_-90831611": {
            "id": -90831611,
            "latitude": 57.660084,
            "longitude": 63.093462,
            "index": 769,
            "is_stop": 0,
            "segment_id": -90718250,
            "segment_index": 86
        },
        "point_-90831835": {
            "id": -90831835,
            "latitude": 57.660155,
            "longitude": 63.093321,
            "index": 771,
            "is_stop": 0,
            "segment_id": -90831766,
            "segment_index": 87
        },
        "point_-90818207": {
            "id": -90818207,
            "latitude": 57.662068,
            "longitude": 63.089484,
            "index": 773,
            "is_stop": 0,
            "segment_id": -90831878,
            "segment_index": 88
        },
        "point_-90818451": {
            "id": -90818451,
            "latitude": 57.662133,
            "longitude": 63.089361,
            "index": 775,
            "is_stop": 0,
            "segment_id": -90818377,
            "segment_index": 89
        },
        "point_1135988114": {
            "id": 1135988114,
            "latitude": 57.66239,
            "longitude": 63.088851,
            "index": 777,
            "is_stop": 0,
            "segment_id": -90818489,
            "segment_index": 90
        },
        "point_-90718249": {
            "id": -90718249,
            "latitude": 57.663167,
            "longitude": 63.087349,
            "index": 778,
            "is_stop": 0,
            "segment_id": -90818489,
            "segment_index": 90
        },
        "point_-90718761": {
            "id": -90718761,
            "latitude": 57.663252,
            "longitude": 63.08718,
            "index": 780,
            "is_stop": 0,
            "segment_id": -91284728,
            "segment_index": 91
        },
        "point_-90858273": {
            "id": -90858273,
            "latitude": 57.664758,
            "longitude": 63.08413,
            "index": 782,
            "is_stop": 0,
            "segment_id": -90718874,
            "segment_index": 92
        },
        "point_1135987258": {
            "id": 1135987258,
            "latitude": 57.664803,
            "longitude": 63.084147,
            "index": 784,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_1129831669": {
            "id": 1129831669,
            "latitude": 57.664847,
            "longitude": 63.084195,
            "index": 785,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_1129831757": {
            "id": 1129831757,
            "latitude": 57.664929,
            "longitude": 63.084343,
            "index": 786,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_-91229744": {
            "id": -91229744,
            "latitude": 57.66497,
            "longitude": 63.084463,
            "index": 787,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_1135987801": {
            "id": 1135987801,
            "latitude": 57.66499,
            "longitude": 63.084588,
            "index": 788,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_-91229676": {
            "id": -91229676,
            "latitude": 57.665003,
            "longitude": 63.084728,
            "index": 789,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_-91229618": {
            "id": -91229618,
            "latitude": 57.665217,
            "longitude": 63.085087,
            "index": 790,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_-91229581": {
            "id": -91229581,
            "latitude": 57.665383,
            "longitude": 63.084757,
            "index": 791,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_1135987631": {
            "id": 1135987631,
            "latitude": 57.665302,
            "longitude": 63.084599,
            "index": 792,
            "is_stop": 0,
            "segment_id": -91229556,
            "segment_index": 93
        },
        "point_-90858580": {
            "id": -90858580,
            "latitude": 57.665196,
            "longitude": 63.084426,
            "index": 793,
            "is_stop": 1,
            "segment_id": -91229556,
            "segment_index": 93,
            "stop_id": "-90858580__nis",
            "stop_name": "г. Ирбит АС",
            "transport_type": "АВТОБУС"
        }
    }
}